/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as yup from 'yup';
import {
  Bank,
  ControllingPersons,
  Groups,
  NomineeType,
  nonIndividualQuestionsFatca,
  Applicant,
  uboDomestic,
  uboForeign,
} from '../redux-store/types/api-types';
import {
  stringRegex,
  addressRegex,
  phoneRegExp,
  emailRegex,
  numberRegex,
  alphaNumeric,
  indianPin,
  arnCodeRegex,
  individualPanRegex,
  nonIndividualPanRegex,
  amountRegex,
  pinCodeRegexOtherThanIndia,
  ifscRegex,
  accountNumberRegex,
  ckycNumberRegex,
  stateRegexOtherThanIndia,
} from './regex';
import {
  isMinor,
  currencyConversion,
  maxAge,
  getCountryCodes,
  folioValidationCheck,
  nomineeRelationForAgeMajor,
  isMajor,
  checkRelationshipWithPep,
  getRelationshipWithPepLabel,
  isOtherOccupation,
  shouldValidateUponSaveLater,
  isOnboardingTypeMinor,
  futureDate,
  isFatherMother,
  PlacementFeeApplicable,
  futureAge,
  checkForCorrespondenceAddress,
  IsInvestorWithPAN,
  isIbancountry,
  checkValidationBasedOnDate,
  checkNonResident,
  isFieldApplicable,
  isFieldTypeVariable,
  isFieldTypeFixed,
  isNriAndPioStatus,
  minNetworthDate,
  IsOutBoundFundFlow,
  getBankAccountTypeMaster,
  isNonResidentDeclaration,
  isRiSchemeId3,
  isTaxResidencyDeclarationScheme,
  isUSTechFund,
  isRiOutboundFund,
  isOutboundFund,
} from './utilityFunctions';
import { InternalOptions } from 'yup/lib/types';
import { Values } from '../components/investors/ContactDetails';
import { Distributor, SubDistributor } from '../redux-store/actions';
import { Values as ContributorValues } from '../components/investors/InvestorWithPan/ContributorDetails';
import { Values as DocumentValues } from '../components/investors/documentDetails';
import { Values as NonIndividualDocValues } from '../components/NonIndividualInvestor/DocumentDetails';
import { getSubQuestionsIndex } from '../components/NonIndividualInvestor/fatca';
import {
  addressTypesMasters,
  addressTypesMastersforoutbound,
  adminSupportMaster,
  applicantStatusMasters,
  APPLICATION_TYPE,
  BankAccountTypeForVenture,
  BankAccountTypeMaster,
  BankBranchMandatoryDate,
  bankType,
  CpUboCodesMaster,
  feeTypeMaster,
  flowTypeMaster,
  genderMasters,
  grossAnnualMasters,
  INBOUND_BANK_ACC_TYPE_CHANGE_DATE,
  indiaOpportunitiesFundOccupationMaster,
  investorTypeMasters,
  investorTypeOutboundMasters,
  isNaturalParent,
  JOURNEY_TYPE,
  MASTER_DESIGNATION,
  NomineeRelations,
  NomineeRelationsXalt,
  NRIBankAccountTypeMaster,
  occupationDetailsMasters,
  occupationDetailsOutboundMasters,
  otherRelations,
  OUTBOUND_BANK_ACC_TYPE_CHANGE_DATE,
  PEPsMasters,
  ReasonMaster,
  Relations,
  RelationsXalt,
  SourceOfFundsMaster,
  subdistributorTypes,
  USPersonDateValidation,
  yesNoMaster,
} from './constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { Values as NonIndividualContactValues } from '../components/NonIndividualInvestor/ContactDetails';
import { Values as individualFatcaValues } from '../components/investors/fatca';
import { checkOthers } from '../components/investors/additionalKYCDetails';
import { mdmsCountriesList } from '../redux-store/types/mdms';

export const contributorDetailsSchemaWithPan = (
  fundFlowType: string,
  createdAt: string,
  ifXalt?: boolean,
  schemeId?: string
) =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .nullable()
          .test('name', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Name is required',
                path,
              });
            }
            return true;
          }),
        gender: yup
          .string()
          .nullable()
          .oneOf(genderMasters, 'Invalid value for Gender')
          .test('gender', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Please select gender',
                path,
              });
            }
            return true;
          }),
        motherName: yup
          .string()
          .nullable()
          .matches(stringRegex, 'Special characters and numbers not allowed'),
        fatherOrSpouseName: yup
          .string()
          .nullable()
          .test('fatherOrSpouseName', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Father/Spouse Name is required',
                path,
              });
            }
            return true;
          }),
        dateOfBirth: yup
          .string()
          .nullable()
          .test(
            'dateOfBirth',
            'Age should be greater than 18',
            (dateOfBirth) => !isMinor(dateOfBirth || '')
          )
          .test('dateOfBirth', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Date of Birth is required',
                path,
              });
            }
            return true;
          }),
        status: yup
          .string()
          .nullable()
          .oneOf(Object.keys(applicantStatusMasters), 'Invalid value for Status')
          .test('status', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Status is required',
                path,
              });
            }
            return true;
          }),
        nationality: yup
          .string()
          .nullable()
          .test('nationality', (value, context) => {
            const fieldValue = value === null ? '' : value;
            // eslint-disable-next-line
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<ContributorValues>;
            const { nationalityDropdown = [] } = optionsContext || {};
            if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
              return createError({
                message: 'Nationality is required',
                path,
              });
            }
            if (fieldValue && !nationalityDropdown.includes(fieldValue)) {
              return createError({
                message: 'Invalid value for Nationality',
                path,
              });
            }
            // if (
            //   applicantStatusMasters[parent.status] === applicantStatusMasters.NRI &&
            //   value?.toUpperCase() !== 'INDIAN'
            // ) {
            //   return createError({
            //     message: 'Invalid value for Nationality',
            //     path,
            //   });
            // }
            return true;
          }),
        usPerson: yup
          .string()
          .nullable()
          .test('usPerson', (value, context) => {
            const { options, path, createError, parent } = context;
            // Outbounds + RI: the US Person field is hidden, so it is not required.
            if (isRiOutboundFund(parent?.status, schemeId)) {
              return true;
            }
            if (!value && checkValidationBasedOnDate(createdAt, USPersonDateValidation)) {
              return createError({
                message: 'Are you US Person is required ',
                path,
              });
            }
            return true;
          }),

        jointApplicantRelation: yup
          .string()
          .nullable()
          .test('jointApplicationRelation', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path } = context;
            const { index } = options as InternalOptions<ContributorValues> & {
              index: number;
            };

            if (index !== 0) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType || '')) {
                return createError({
                  message: 'Relationship with first applicant is required',
                  path,
                });
              }
              if (
                fieldValue &&
                !(ifXalt ? RelationsXalt.concat(otherRelations) : Relations).includes(fieldValue)
              ) {
                return createError({
                  message: 'Invalid value for Relationship with first applicant',
                  path,
                });
              }
            }
            return true;
          }),
        relationShipWithFirstApplicant: yup
          .string()
          .nullable()
          .when('jointApplicantRelation', {
            is: (jointApplicantRelation: string | null) =>
              jointApplicantRelation === 'Others' && !ifXalt,
            then: yup
              .string()
              .nullable()
              .test('relationShipWithFirstApplicant', (value, context) => {
                const {
                  options: { context: optionsContext },
                  path,
                  createError,
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Please Specify Relationship',
                    path,
                  });
                }
                return true;
              }),
          }),
        minorPan: yup
          .string()
          .nullable()
          .uppercase()
          .length(10, 'PAN must be exactly 10 characters')
          .test('pan', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent } = context;
            if (!fieldValue) {
              return true;
            }
            if (!individualPanRegex.test(fieldValue)) {
              return createError({
                message: 'Only individual PANs are allowed',
                path,
              });
            }
            if (fieldValue === parent.panNo) {
              return createError({
                message: 'Minor PAN should not be same as Guardian PAN',
                path,
              });
            }
            return true;
          }),
        minorDOB: yup
          .string()
          .nullable()
          .test('minorDOB', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (isOnboardingTypeMinor(parent.onboardingType)) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Date of Birth is required',
                  path,
                });
              }
              if (futureAge(fieldValue || '')) {
                return createError({
                  message: 'Future date cannot be entered',
                  path,
                });
              }
              if (fieldValue && !isMinor(fieldValue)) {
                return createError({
                  message: 'Age should be less than 18',
                  path,
                });
              }
            }
            return true;
          }),
        minorName: yup
          .string()
          .nullable()
          .test('minorName', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Minor Name is required',
                path,
              });
            }
            return true;
          }),
        //   .string()
        //   .nullable()
        //   .test('minorFirstName', (value, context) => {
        //     const fieldValue = value === undefined ? '' : value;
        //     const { path, createError, parent } = context;
        //     if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
        //       return createError({
        //         message: 'Minor First Name is required',
        //         path,
        //       });
        //     }
        //     return true;
        //   }),
        // minorLastName: yup
        //   .string()
        //   .nullable()
        //   .test('minorLastName', (value, context) => {
        //     const fieldValue = value === undefined ? '' : value;
        //     const { path, createError, parent } = context;
        //     if (!fieldValue && isOnboardingTypeMinor(parent.onboardingType)) {
        //       return createError({
        //         message: 'Minor Last Name is required',
        //         path,
        //       });
        //     }
        //     return true;
        //   }),
        guardianRelationship: yup
          .string()
          .nullable()
          .test('guardianRelationship', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Relationship with guardian is required',
                path,
              });
            }
            return true;
          }),
        naturalParent: yup
          .string()
          .nullable()
          .test('naturalParent', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              isOnboardingTypeMinor(parent.onboardingType) &&
              isFatherMother(parent.guardianRelationship || '')
            ) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Natural Parents field is required',
                  path,
                });
              } else if (fieldValue && !Object.keys(isNaturalParent).includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for Natural Parents',
                  path,
                });
              }
            }
            return true;
          }),
        guardianRelationshipTypeOther: yup
          .string()
          .nullable()
          .test('guardianRelationshipTypeOther', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              isOnboardingTypeMinor(parent.onboardingType) &&
              parent.guardianRelationship === 'OTHERS'
            ) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Please specify Relationship with guardian is required',
                  path,
                });
              } else if (fieldValue && !stringRegex.test(fieldValue)) {
                return createError({
                  message: 'Special characters and numbers not allowed',
                  path,
                });
              }
            }
            return true;
          }),
        minorFatherName: yup
          .string()
          .nullable()
          .test('minorFatherName', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Minor Father Name is required',
                path,
              });
            }
            return true;
          }),
        minorGender: yup
          .string()
          .nullable()
          .test('minorGender', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Minor Gender is required',
                path,
              });
            }
            return true;
          }),

        minorEmail: yup.string().nullable().matches(emailRegex, 'Invalid Email ID'),
        minorMobile: yup
          .string()
          .nullable()
          .test('minorMobile', (value, context) => {
            const { createError, path, parent } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === parent.minorCountryNameAndCode) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            // if (
            //   value &&
            //   parent.minorCountryNameAndCode === 'India: +91' &&
            //   // eslint-disable-next-line
            //   !phoneRegExp.test(value as any)
            // ) {
            //   return createError({
            //     message: 'Invalid Mobile number',
            //     path,
            //   });
            // }
            // eslint-disable-next-line
            if (
              value &&
              !isValidPhoneNumber(
                (parent?.minorCountryNameAndCode?.split(':')[1].trim() + value) as any,
                codesList as CountryCode
              )
            ) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }
            return true;
          }),
        taxResidencyDocumentType: yup
          .string()
          .nullable()
          .when('status', {
            is: (status: string) => checkNonResident(status),
            then: yup
              .string()
              .nullable()
              .test('taxResidencyDocumentType', (value, context) => {
                const {
                  options: { context: optionsContext },
                  path,
                  createError,
                } = context;
                if (
                  !value &&
                  shouldValidateUponSaveLater(optionsContext?.saveType) &&
                  !isOutboundFund(schemeId || '')
                ) {
                  return createError({
                    message: 'Tax Residency Document Type is required',
                    path,
                  });
                }
                return true;
              }),
          }),
        taxYear: yup
          .string()
          .nullable()
          .when('taxResidencyDocumentType', {
            is: (taxResidencyDocumentType: string) =>
              isNonResidentDeclaration(taxResidencyDocumentType) &&
              isTaxResidencyDeclarationScheme(schemeId || ''),
            then: yup
              .string()
              .nullable()
              .required('Tax Year is required')
              .matches(/^FY \d{4}-\d{2}$/, 'Tax Year must be in the format FY 2025-26'),
          }),
        nriPioContactedPersonName: yup
          .string()
          .nullable()
          .when('status', {
            is: (value: string) => isNriAndPioStatus(value) && IsOutBoundFundFlow(fundFlowType),
            then: yup.string().nullable().required('NRI - PIO Contacted Person name is required'),
          }),
        ckycNo: yup
          .string()
          .nullable()
          .test('ckycNo', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const {
              options: { context: optionsContext },
              createError,
              path,
              parent,
            } = context;
            const { applicants } = optionsContext || {};
            if (!fieldValue) {
              return true;
            } else if (!ckycNumberRegex.test(fieldValue as string) && !parent.maskedCkycNo) {
              return createError({
                message: 'Invalid CKYC No./CKYC Acknowledge No./KIN No',
                path,
              });
              // } else if (!numberRegex.test(fieldValue)) {
              //   return createError({
              //     message: 'CKYC No./CKYC Acknowledge No./KIN No allows only digits',
              //     path,
              //   });
            }
            //  else if (
            //   applicants.filter((applicant: Applicant) => applicant.ckycNo === fieldValue).length >
            //   1
            // ) {
            //   return createError({
            //     message:
            //       'There is already same CKYC Number for an applicant associated with this application',
            //     path,
            //   });
            // }
            return true;
          }),
      })
    ),
  });

export const contributorDetailsSchemaWithoutPan = (
  createdAt: string,
  ifXalt?: boolean,
  schemeId?: string
) =>
  yup.object().shape({
    folio_no: yup
      .string()
      .nullable()
      .when('applicationSource', {
        is: (applicationSource: string) => folioValidationCheck(applicationSource),
        then: yup
          .string()
          .nullable()
          .matches(alphaNumeric, 'Special characters are not allowed')
          .test('folio_no', 'Folio Number is required', (value, context) => {
            const {
              options: { context: optionsContext },
            } = context;
            return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
          }),
      }),
    applicants: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .nullable()
          .test('name', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Name is required',
                path,
              });
            }
            return true;
          }),
        gender: yup
          .string()
          .nullable()
          .oneOf(genderMasters, 'Invalid value for Gender')
          .test('gender', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Please select gender',
                path,
              });
            }
            return true;
          }),
        motherName: yup
          .string()
          .nullable()
          .matches(stringRegex, 'Special characters and numbers not allowed'),
        fatherOrSpouseName: yup
          .string()
          .nullable()
          .test('fatherOrSpouseName', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Father/Spouse Name is required',
                path,
              });
            }
            return true;
          }),
        dateOfBirth: yup
          .string()
          .nullable()
          // .test(
          //   'dateOfBirth',
          //   'Age should be greater than 18',
          //   (dateOfBirth) => !isMinor(dateOfBirth || '')
          // )
          .test('dateOfBirth', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Date of Birth is required',
                path,
              });
            }
            return true;
          }),
        pan: yup
          .string()
          .nullable()
          .when('panDeclaration', {
            is: (panDeclaration: boolean) => !panDeclaration,
            then: yup
              .string()
              .nullable()
              .uppercase()
              .length(10, 'PAN must be exactly 10 characters')
              .test('pan', (value, context) => {
                const fieldValue = value === undefined ? '' : value;
                const { path, createError, parent } = context;
                if (!fieldValue) {
                  return createError({
                    message: 'PAN is required',
                    path,
                  });
                }
                if (!individualPanRegex.test(fieldValue)) {
                  return createError({
                    message: 'Only individual PANs are allowed',
                    path,
                  });
                }
                return true;
              }),
          }),

        // status: yup
        //   .string()
        //   .nullable()
        //   .required('Status is required'),
        nationality: yup
          .string()
          .nullable()
          .test('nationality', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<ContributorValues>;
            const { nationalityDropdown = [] } = optionsContext || {};
            if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
              return createError({
                message: 'Country of Nationality is required',
                path,
              });
            }
            if (fieldValue && !nationalityDropdown.includes(fieldValue)) {
              return createError({
                message: 'Invalid value for Nationality',
                path,
              });
            }
            // if (
            //   applicantStatusMasters[parent.status] === applicantStatusMasters.NRI &&
            //   value?.toUpperCase() !== 'INDIAN'
            // ) {
            //   return createError({
            //     message: 'Invalid value for Nationality',
            //     path,
            //   });
            // }
            return true;
          }),
        usPerson: yup
          .string()
          .nullable()
          .test('usPerson', (value, context) => {
            const { options, path, createError, parent } = context;
            // Outbounds + RI: the US Person field is hidden, so it is not required.
            if (isRiOutboundFund(parent?.status, schemeId)) {
              return true;
            }
            if (!value && checkValidationBasedOnDate(createdAt, USPersonDateValidation)) {
              return createError({
                message: 'Are you US Person is required ',
                path,
              });
            }
            return true;
          }),
        jointApplicantRelation: yup
          .string()
          .nullable()
          .test('jointApplicationRelation', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path } = context;
            const { index } = options as InternalOptions<ContributorValues> & {
              index: number;
            };

            if (index !== 0) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType || '')) {
                return createError({
                  message: 'Relationship with first applicant is required',
                  path,
                });
              }
              if (
                fieldValue &&
                !(ifXalt ? RelationsXalt.concat(otherRelations) : Relations).includes(fieldValue)
              ) {
                return createError({
                  message: 'Invalid value for Relationship with first applicant',
                  path,
                });
              }
            }
            return true;
          }),
        relationShipWithFirstApplicant: yup
          .string()
          .nullable()
          .when('jointApplicantRelation', {
            is: (jointApplicantRelation: string | null) =>
              jointApplicantRelation === 'Others' && !ifXalt,
            then: yup
              .string()
              .nullable()
              .test('relationShipWithFirstApplicant', (value, context) => {
                const {
                  options: { context: optionsContext },
                  path,
                  createError,
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Please Specify Relationship',
                    path,
                  });
                }
                return true;
              }),
          }),
        minorPan: yup
          .string()
          .nullable()
          .uppercase()
          .test('pan', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent } = context;
            if (!fieldValue) {
              return true;
            }
            if (fieldValue === parent.taxIdNumber) {
              return createError({
                message: 'Minor ID number should not be same as Guardian ID number',
                path,
              });
            }
            return true;
          }),
        minorDOB: yup
          .string()
          .nullable()
          .test('minorDOB', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (isOnboardingTypeMinor(parent.onboardingType)) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Date of Birth is required',
                  path,
                });
              }
              if (futureDate(fieldValue || '')) {
                return createError({
                  message: 'Future date cannot be entered',
                  path,
                });
              }
              if (fieldValue && !isMinor(fieldValue)) {
                return createError({
                  message: 'Age should be less than 18',
                  path,
                });
              }
            }
            return true;
          }),
        minorName: yup
          .string()
          .nullable()
          .test('minorName', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Minor Name is required',
                path,
              });
            }
            return true;
          }),
        guardianRelationship: yup
          .string()
          .nullable()
          .test('guardianRelationship', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Relationship with guardian is required',
                path,
              });
            }
            return true;
          }),
        naturalParent: yup
          .string()
          .nullable()
          .test('naturalParent', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              isOnboardingTypeMinor(parent.onboardingType) &&
              isFatherMother(parent.guardianRelationship || '')
            ) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Natural Parents field is required',
                  path,
                });
              } else if (fieldValue && !Object.keys(isNaturalParent).includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for Natural Parents',
                  path,
                });
              }
            }
            return true;
          }),
        guardianRelationshipTypeOther: yup
          .string()
          .nullable()
          .test('guardianRelationshipTypeOther', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              isOnboardingTypeMinor(parent.onboardingType) &&
              parent.guardianRelationship === 'OTHERS'
            ) {
              if (!fieldValue && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Please specify Relationship with guardian is required',
                  path,
                });
              } else if (fieldValue && !stringRegex.test(fieldValue)) {
                return createError({
                  message: 'Special characters and numbers not allowed',
                  path,
                });
              }
            }
            return true;
          }),
        minorFatherName: yup
          .string()
          .nullable()
          .test('minorFatherName', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Minor Father Name is required',
                path,
              });
            }
            return true;
          }),
        minorGender: yup
          .string()
          .nullable()
          .test('minorGender', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            if (
              !fieldValue &&
              isOnboardingTypeMinor(parent.onboardingType) &&
              shouldValidateUponSaveLater(options.context?.saveType)
            ) {
              return createError({
                message: 'Minor Gender is required',
                path,
              });
            }
            return true;
          }),

        minorEmail: yup.string().nullable().matches(emailRegex, 'Invalid Email ID'),
        minorMobile: yup
          .string()
          .nullable()
          .test('minorMobile', (value, context) => {
            const { createError, path, parent } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === parent.minorCountryNameAndCode) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            // if (
            //   value &&
            //   parent.minorCountryNameAndCode === 'India: +91' &&
            //   !phoneRegExp.test(value as any)
            // ) {
            //   return createError({
            //     message: 'Invalid Mobile number',
            //     path,
            //   });
            // }
            if (
              value &&
              !isValidPhoneNumber(
                (parent?.minorCountryNameAndCode?.split(':')[1].trim() + value) as any,
                codesList as CountryCode
              )
            ) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }
            return true;
          }),
        taxResidencyDocumentType: yup
          .string()
          .nullable()
          .when('status', {
            is: (status: string) => checkNonResident(status),
            then: yup
              .string()
              .nullable()
              .test('taxResidencyDocumentType', (value, context) => {
                const {
                  options: { context: optionsContext },
                  path,
                  createError,
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Tax Residency Document Type is required',
                    path,
                  });
                }
                return true;
              }),
          }),
      })
    ),
  });

const validatePermanentAddressFields = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  applicationType: string,
  flowType: string | null | undefined
) => {
  const fieldValue = !value ? '' : value;
  const { options } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status = '' } = currentApplicant.address;
  const { permanentAddressSameAsCorresponding = false } =
    checkForCorrespondenceAddress(nationality, status, flowType) ||
    APPLICATION_TYPE.NON_INDIVIDUAL === applicationType
      ? currentApplicant.address.correspondence || {}
      : currentApplicant.address.overseas || {};
  return permanentAddressSameAsCorresponding ? true : fieldValue !== '';
};

const validateCorrespondenceAddressFields = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  flowType: string | null | undefined
) => {
  const fieldValue = !value ? '' : value;
  const { options } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status = '' } = currentApplicant.address;
  return checkForCorrespondenceAddress(nationality, status, flowType) ? fieldValue !== '' : true;
};

const validateOverseasAddressFields = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  flowType: string | null | undefined
) => {
  const fieldValue = !value ? '' : value;
  const { options } = context;
  const { context: optionsContext, index } = options as InternalOptions<Values> & {
    index: number;
  };
  const { applicants = [] } = optionsContext || {};
  const currentApplicant = applicants[index] || {};
  const { nationality, status } = currentApplicant.address;
  return checkForCorrespondenceAddress(nationality, status, flowType) ? true : fieldValue !== '';
};

const validatePincodeField = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>
) => {
  const fieldValue = value === undefined ? '' : value;
  const { options, path, createError, parent } = context;
  const { context: optionsContext } = options as InternalOptions<Values> & {
    index: number;
  };
  if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
    return true;
  }
  if (fieldValue && parent.country?.toLowerCase() === 'india' && !indianPin.test(fieldValue)) {
    return createError({
      message: 'Pincode should be 6 digit code',
      path,
    });
  }
  if (
    fieldValue &&
    parent.country?.toLowerCase() !== 'india' &&
    !pinCodeRegexOtherThanIndia.test(fieldValue)
  ) {
    return createError({
      message: 'Invalid Pincode',
      path,
    });
  }

  return true;
};

export const contactDetailsSchemaWithPan = (flowType = '') =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        phoneNumberoffice: yup.string().nullable(),
        phoneNumberResidence: yup.string().nullable(),
        email: yup
          .string()
          .nullable()
          .matches(emailRegex, 'Invalid Email ID')
          .test('email', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (
              !value &&
              shouldValidateUponSaveLater(optionsContext?.saveType) &&
              !IsInvestorWithPAN(flowType)
            ) {
              return createError({
                message: 'Email is required',
                path,
              });
            }
            return true;
          }),
        mobile: yup
          .string()
          .nullable()
          .test('mobile', (value, context) => {
            const { createError, path, parent, options } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === parent.countryNameAndCode) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            if (
              !value &&
              shouldValidateUponSaveLater(options.context?.saveType) &&
              !IsInvestorWithPAN(flowType)
            ) {
              return createError({
                message: 'Mobile is required',
                path,
              });
            }
            // if (value && parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
            //   return createError({
            //     message: 'Invalid Mobile number',
            //     path,
            //   });
            // }
            if (
              value &&
              !IsInvestorWithPAN(flowType) &&
              !isValidPhoneNumber(
                parent?.countryNameAndCode?.split(':')[1].trim() + value,
                codesList as CountryCode
              )
            ) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }

            return true;
          }),
        countryNameAndCode: yup
          .string()
          .nullable()
          .test('countryNameAndCode', (value, context) => {
            const { createError, path, parent, options } = context;
            const codesList = getCountryCodes()
              .map((codes) => {
                if (codes.label === value) {
                  return codes.countryCode;
                }
              })
              .filter((ele) => ele)
              .toString();
            if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
              return createError({
                message: 'Country Code is required',
                path,
              });
            }
            if (
              parent.mobile &&
              !isValidPhoneNumber(
                value?.split(':')[1].trim() + parent.mobile,
                codesList as CountryCode
              )
            ) {
              return createError({
                message: 'Invalid Mobile number',
                path,
              });
            }

            return true;
          }),
        address: yup.object().shape({
          correspondence: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) => {
                const {
                  options: { context: optionsContext },
                } = context;
                if (shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return validateCorrespondenceAddressFields(value, context, flowType);
                }
                return true;
              }),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
                if (
                  !fetchedFromKRA &&
                  shouldValidateUponSaveLater(optionsContext?.saveType || '')
                ) {
                  return validateCorrespondenceAddressFields(value, context, flowType);
                }
                return true;
              }),
            address3: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 3 format [special characters are not allowed except -/',&()#:.]"
              ),
            //   .test('address3', 'Address line 3 is required', (value, context) => {
            //     const { options } = context;
            //     const { context: optionsContext, index } = options as InternalOptions<Values> & {
            //       index: number;
            //     };
            //     const { applicants = [] } = optionsContext || {};
            //     const currentApplicant = applicants[index] || {};
            //     const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
            //     if (!fetchedFromKRA && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
            //       return validateCorrespondenceAddressFields(value, context);
            //     }
            //     return true;
            //   }),
            pincode: yup
              .string()
              .nullable()
              .test('pincode', (value, context) => validatePincodeField(value, context)),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) => {
                const {
                  options: { context: optionsContext },
                } = context;
                if (shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return validateCorrespondenceAddressFields(value, context, flowType);
                }
                return true;
              }),
            // state: yup
            //   .string()
            //   .nullable()
            //   .test('state', 'State is required', (value, context) => {
            //     const {
            //       options: { context: optionsContext },
            //     } = context;
            //     if (shouldValidateUponSaveLater(optionsContext?.saveType)) {
            //       return validateCorrespondenceAddressFields(value, context);
            //     }
            //     return true;
            //   }),
            state: yup
              .string()
              .nullable()
              .test('state', (value, context) => {
                const { path, createError, parent, options } = context;
                const { context: optionsContext } = options;
                const fieldValue = value === undefined ? '' : value;
                const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
                if (
                  fieldValue &&
                  !isIndia &&
                  shouldValidateUponSaveLater(optionsContext?.saveType) &&
                  !stateRegexOtherThanIndia.test(fieldValue as string)
                ) {
                  return createError({
                    message: 'Invalid State',
                    path,
                  });
                }
                return true;
              }),
            // country: yup
            // .string()
            // .nullable()
            // .test('country', 'Country is required', (value, context) =>
            // validateCorrespondenceAddressFields(value, context)
            // ),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { countryDropdown = [], applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status = '' } = currentApplicant.address;

                if (
                  !value &&
                  checkForCorrespondenceAddress(nationality, status, flowType) &&
                  shouldValidateUponSaveLater(optionsContext?.saveType || '')
                ) {
                  return createError({
                    message: 'Country is required',
                    path,
                  });
                }
                if (
                  value &&
                  checkForCorrespondenceAddress(nationality, status, flowType) &&
                  !countryDropdown.includes(value)
                ) {
                  return createError({
                    message: 'Invalid value for Country',
                    path,
                  });
                }
                return true;
              }),
          }),
          overseas: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) => {
                const { options } = context;
                if (shouldValidateUponSaveLater(options.context?.saveType)) {
                  return validateOverseasAddressFields(value, context, flowType);
                }
                return true;
              }),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
                if (
                  !fetchedFromKRA &&
                  shouldValidateUponSaveLater(optionsContext?.saveType || '')
                ) {
                  return validateOverseasAddressFields(value, context, flowType);
                }
                return true;
              }),
            address3: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 3 format [special characters are not allowed except -/',&()#:.]"
              ),
            // .test('address3', 'Address line 3 is required', (value, context) => {
            //   const { options } = context;
            //   const { context: optionsContext, index } = options as InternalOptions<Values> & {
            //     index: number;
            //   };
            //   const { applicants = [] } = optionsContext || {};
            //   const currentApplicant = applicants[index] || {};
            //   const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
            //   if (!fetchedFromKRA && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
            //     return validateOverseasAddressFields(value, context);
            //   }
            //   return true;
            // }),
            pincode: yup
              .string()
              .nullable()
              .test('pincode', (value, context) => validatePincodeField(value, context)),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) => {
                const { options } = context;
                if (shouldValidateUponSaveLater(options.context?.saveType)) {
                  return validateOverseasAddressFields(value, context, flowType);
                }
                return true;
              }),
            // state: yup
            //   .string()
            //   .nullable()
            //   .test('state', 'State is required', (value, context) =>
            //     validateOverseasAddressFields(value, context)
            //   ),
            state: yup
              .string()
              .nullable()
              .test('state', (value, context) => {
                const { path, createError, parent, options } = context;
                const { context: optionsContext } = options;
                const fieldValue = value === undefined ? '' : value;
                const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
                if (
                  fieldValue &&
                  !isIndia &&
                  shouldValidateUponSaveLater(optionsContext?.saveType) &&
                  !stateRegexOtherThanIndia.test(fieldValue as string)
                ) {
                  return createError({
                    message: 'Invalid State',
                    path,
                  });
                }
                return true;
              }),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [], countryDropdown = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status = '' } = currentApplicant.address;
                if (!value && checkForCorrespondenceAddress(nationality, status, flowType)) {
                  return true;
                }
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                  return createError({
                    message: 'Country is required',
                    path,
                  });
                }
                if (value && value.toUpperCase() === 'INDIA') {
                  return createError({
                    message: "Country can't be choosen as INDIA",
                    path,
                  });
                }
                if (value && !countryDropdown.includes(value)) {
                  return createError({
                    message: 'Invalid value for Country',
                    path,
                  });
                }
                return true;
              }),
            // country: yup
            //   .string()
            //   .nullable()
            //   .test('country', 'Country is required', (value, context) =>
            //     validateOverseasAddressFields(value, context)
            //   ),
          }),
          permanent: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) => {
                const { options } = context;
                if (shouldValidateUponSaveLater(options?.context?.saveType)) {
                  return validatePermanentAddressFields(
                    value,
                    context,
                    APPLICATION_TYPE.INDIVIDUAL,
                    flowType
                  );
                }
                return true;
              }),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { fetchedFromKRA = null } = currentApplicant.address.permanent || {};
                if (
                  !fetchedFromKRA &&
                  shouldValidateUponSaveLater(optionsContext?.saveType || '')
                ) {
                  return validatePermanentAddressFields(
                    value,
                    context,
                    APPLICATION_TYPE.INDIVIDUAL,
                    flowType
                  );
                }
                return true;
              }),
            address3: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 3 format [special characters are not allowed except -/',&()#:.]"
              ),
            // .test('address3', 'Address line 3 is required', (value, context) => {
            //   const { options } = context;
            //   const { context: optionsContext, index } = options as InternalOptions<Values> & {
            //     index: number;
            //   };
            //   const { applicants = [] } = optionsContext || {};
            //   const currentApplicant = applicants[index] || {};
            //   const { fetchedFromKRA = null } = currentApplicant.address.permanent || {};
            //   if (!fetchedFromKRA && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
            //     return validatePermanentAddressFields(value, context, APPLICATION_TYPE.INDIVIDUAL);
            //   }
            //   return true;
            // }),
            pincode: yup
              .string()
              .trim()
              .nullable()
              .test('pincode', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status = '' } = currentApplicant.address;
                const { permanentAddressSameAsCorresponding = false } =
                  checkForCorrespondenceAddress(nationality, status, flowType)
                    ? currentApplicant.address.correspondence || {}
                    : currentApplicant.address.overseas || {};
                if (!permanentAddressSameAsCorresponding) {
                  return validatePincodeField(value, context);
                }
                return true;
              }),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) => {
                const { options } = context;
                if (shouldValidateUponSaveLater(options.context?.saveType)) {
                  return validatePermanentAddressFields(
                    value,
                    context,
                    APPLICATION_TYPE.INDIVIDUAL,
                    flowType
                  );
                }
                return true;
              }),
            // state: yup
            //   .string()
            //   .nullable()
            //   .test('state', 'State is required', (value, context) => {
            //     const { options } = context;
            //     if (shouldValidateUponSaveLater(options.context?.saveType)) {
            //       return validatePermanentAddressFields(value, context, APPLICATION_TYPE.INDIVIDUAL);
            //     }
            //     return true;
            //   }),
            state: yup
              .string()
              .nullable()
              .test('state', (value, context) => {
                const { path, createError, parent, options } = context;
                const { context: optionsContext } = options;
                const fieldValue = value === undefined ? '' : value;
                const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
                if (
                  fieldValue &&
                  !isIndia &&
                  shouldValidateUponSaveLater(optionsContext?.saveType) &&
                  !stateRegexOtherThanIndia.test(fieldValue as string)
                ) {
                  return createError({
                    message: 'Invalid State',
                    path,
                  });
                }
                return true;
              }),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { countryDropdown = [] } = optionsContext || {};
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { nationality, status } = currentApplicant.address;
                const { permanentAddressSameAsCorresponding = false } =
                  checkForCorrespondenceAddress(nationality, status, flowType)
                    ? currentApplicant.address.correspondence || {}
                    : currentApplicant.address.overseas || {};
                if (!permanentAddressSameAsCorresponding) {
                  if (!value && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                    return createError({
                      message: 'Country is required',
                      path,
                    });
                  }
                  // if (
                  //   applicantStatusMasters[status || ''] === applicantStatusMasters.NRI &&
                  //   value.toUpperCase() === 'INDIA'
                  // ) {
                  //   return createError({
                  //     message:
                  //       "If the Status is Individual (NRI) then Country can't be choosen as INDIA",
                  //     path,
                  //   });
                  // }
                  if (value && !countryDropdown.includes(value)) {
                    return createError({
                      message: 'Invalid value for Country',
                      path,
                    });
                  }
                }
                return true;
              }),
            // country: yup
            //   .string()
            //   .nullable()
            //   .test('country', 'Country is required', (value, context) =>
            //     validatePermanentAddressFields(value, context)
            //   ),
          }),
        }),
      })
    ),
  });

export const KYCDetailsSchema = (createdAt = '', schemeId = '') =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        occupationDetails: yup.string().test('occupationDetails', (value, context) => {
          const {
            options: { context: optionsContext },
            path,
            createError,
          } = context;
          const allowed = isTaxResidencyDeclarationScheme(schemeId || '')
            ? indiaOpportunitiesFundOccupationMaster
            : IsOutBoundFundFlow(optionsContext?.fundFlowType)
            ? occupationDetailsOutboundMasters
            : occupationDetailsMasters;

          if (!allowed.includes(value ?? '')) {
            return createError({ message: 'Invalid value for occupation details' });
          }

          if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
            return createError({
              message: 'Occupation details is required',
              path,
            });
          }
          return true;
        }),
        otherOccupationDetails: yup.string().when('occupationDetails', {
          is: (occupationDetails: string) => isOtherOccupation(occupationDetails),
          then: yup
            .string()
            .nullable()
            .test('otherOccupationDetails', (value, context) => {
              const {
                options: { context: optionsContext },
                path,
                createError,
              } = context;
              if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                return createError({
                  message: 'Other occupation is required',
                  path,
                });
              }
              return true;
            }),
        }),

        netWorth: yup
          .string()
          .nullable()
          .test('netWorth', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, options } = context;
            if (IsOutBoundFundFlow(options?.context?.fundFlowType)) {
              // if (!fieldValue && shouldValidateUponSaveLater(options?.context?.saveType)) {
              //   return createError({
              //     message: 'Net Worth is required',
              //     path,
              //   });
              // }
              if (fieldValue && !amountRegex.test(fieldValue)) {
                return createError({
                  message: 'Invalid amount',
                  path,
                });
              }
            }
            return true;
          }),

        netWorthDate: yup
          .string()
          .nullable()
          .test('netWorthDate', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, options } = context;
            if (IsOutBoundFundFlow(options?.context?.fundFlowType)) {
              // if (!fieldValue && shouldValidateUponSaveLater(options?.context?.saveType)) {
              //   return createError({
              //     message: 'Net Worth Date is required',
              //     path,
              //   });
              // }
              if (fieldValue && new Date(fieldValue) < new Date(minNetworthDate(createdAt))) {
                return createError({
                  message: `Net worth date cannot be older than ${
                    minNetworthDate(createdAt).toISOString().split('T')[0]
                  }`,
                  path,
                });
              }
            }
            return true;
          }),

        politicallyExposedPersonStatus: yup
          .string()
          .oneOf(PEPsMasters, 'Invalid value for PEP Status')
          .test('politicallyExposedPersonStatus', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'PEP status is required',
                path,
              });
            }
            return true;
          }),
        relationshipWithPep: yup
          .string()
          .nullable()
          .when('politicallyExposedPersonStatus', {
            is: (politicallyExposedPersonStatus: string) =>
              checkRelationshipWithPep(politicallyExposedPersonStatus),
            then: yup
              .string()
              .nullable()
              .test('relationshipWithPep', (value, context) => {
                const {
                  options: { context: optionsContext },
                  path,
                  createError,
                  parent,
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: `${getRelationshipWithPepLabel(
                      parent.politicallyExposedPersonStatus
                    )}  is required`,
                    path,
                  });
                }
                return true;
              }),
          }),
        sourceOfFunds: yup
          .array()
          .nullable()
          .min(1, 'Source of funds is required')
          .test('sourceOfFunds', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Source of Funds is required',
                path,
              });
            }
            if (
              value &&
              value?.some(
                (_sourceOfFund) => !Object.keys(SourceOfFundsMaster).includes(_sourceOfFund)
              )
            ) {
              return createError({
                message: 'Invalid value for Source of Funds',
                path,
              });
            }
            return true;
          }),

        otherSourceOfFund: yup.string().when('sourceOfFunds', {
          is: (sourceOfFunds: string[] | null) => checkOthers(sourceOfFunds || []),
          then: yup
            .string()
            .nullable()
            .test('otherSourceOfFund', (value, context) => {
              const {
                options: { context: optionsContext },
                path,
                createError,
              } = context;
              if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                return createError({
                  message: 'Please Specify Source of Funds',
                  path,
                });
              }
              return true;
            }),
        }),
        fundsOriginateFrom: yup.array().nullable(),
        // .required('The funds are derived from or originated from is required'),
        grossAnnualIncome: yup
          .string()
          .nullable()
          .test('grossAnnualIncome', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, options } = context;
            if (fieldValue && !grossAnnualMasters['foreign'].includes(fieldValue)) {
              return createError({
                message: 'Invalid value for Gross Annual Income',
                path,
              });
            }
            return true;
          }),
      })
    ),
  });

const createSchemaForNonIndianResident = (fieldName: string, validationMessage: string) => {
  return {
    is: (
      taxResidentOfAnyCountryOtherThanIndia: string,
      wishToUploadFatcaDocument: boolean | null
    ) => taxResidentOfAnyCountryOtherThanIndia.toString() === 'Yes' && !wishToUploadFatcaDocument,
    then: yup
      .string()
      .nullable()
      .test(fieldName, (value, context) => {
        const { path, createError, options } = context;
        if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
          return createError({
            message: validationMessage,
            path,
          });
        }
        return true;
      }),
  };
};

export const FATCAValidationSchema = (createdAt: string) =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        typeOfAddressProvidedAtKRA: yup
          .string()
          .nullable()
          .when('wishToUploadFatcaDocument', {
            is: (wishToUploadFatcaDocument: boolean | null) => !wishToUploadFatcaDocument,
            then: yup
              .string()
              .nullable()
              .oneOf(addressTypesMasters, 'Invalid value for Type of Address Provided At KRA')
              .test('typeOfAddressProvidedAtKRA', (value, context) => {
                const {
                  options: { context: optionsContext },
                  path,
                  createError,
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Please select type of address provided',
                    path,
                  });
                }
                return true;
              }),
          }),
        placeOfBirth: yup
          .string()
          .nullable()
          .matches(stringRegex, 'Special characters and numbers not allowed'),
        // .when('wishToUploadFatcaDocument', {
        //   is: (wishToUploadFatcaDocument: boolean | null) => !wishToUploadFatcaDocument,
        //   then: yup
        //     .string()
        //     .nullable()
        //     .test('placeOfBirth', 'Please enter place of birth', (value, context) => {
        //       const {
        //         options: { context: optionsContext },
        //       } = context;
        //       return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
        //     }),
        // }),

        // countryOfBirth: yup
        //   .string()
        //   .required('Please enter country of birth')
        //   .matches(stringRegex, 'Please enter country of birth'),
        countryOfBirth: yup
          .string()
          .nullable()
          .test('countryOfBirth', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<individualFatcaValues>;
            const { countriesOfBirthList = [] } = optionsContext || {};
            if (!parent.wishToUploadFatcaDocument) {
              if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                return createError({
                  message: 'country of birth is required',
                  path,
                });
              }
              if (fieldValue && !countriesOfBirthList.includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for country of birth',
                  path,
                });
              }
            }
            return true;
          }),
        // countryOfNationality: yup
        //   .string()
        //   .required('Please enter country of nationality')
        //   .matches(stringRegex, 'Please enter country of nationality'),
        countryOfNationality: yup
          .string()
          .nullable()
          .test('countryOfNationality', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<individualFatcaValues>;
            const { countryDropdown = [] } = optionsContext || {};
            if (!parent.wishToUploadFatcaDocument) {
              if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                return createError({
                  message: 'country of nationality is required',
                  path,
                });
              }
              if (fieldValue && !countryDropdown.includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for country of nationality',
                  path,
                });
              }
            }
            return true;
          }),
        countryOfResidence: yup
          .string()
          .nullable()
          .test('countryOfResidence', (value, context) => {
            const fieldValue = value === null ? '' : value;
            const { options, createError, path, parent } = context;
            const { context: optionsContext } = options as InternalOptions<individualFatcaValues>;
            const { countryDropdown = [] } = optionsContext || {};
            if (!parent.wishToUploadFatcaDocument) {
              if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                return createError({
                  message: 'country of residence is required',
                  path,
                });
              }
              if (fieldValue && !countryDropdown.includes(fieldValue)) {
                return createError({
                  message: 'Invalid value for country of residence',
                  path,
                });
              }
            }
            return true;
          }),

        othersTinNotAvailableReason: yup
          .string()
          .when(
            [
              'taxIdResidentOfAnyCountryOtherThanIndia',
              'idType',
              'tinNotAvailableReason',
              'wishToUploadFatcaDocument',
            ],
            {
              is: (
                taxIdResidentOfAnyCountryOtherThanIndia: string | null,
                idType: string | null,
                tinNotAvailableReason: string | null,
                wishToUploadFatcaDocument: boolean
              ) =>
                taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' &&
                idType === 'OTHERS' &&
                !wishToUploadFatcaDocument &&
                ReasonMaster[tinNotAvailableReason || '']?.code === ReasonMaster.reason_c.code,
              then: yup
                .string()
                .nullable()
                .oneOf(addressTypesMasters, 'Invalid value for Type of Address Provided At KRA')
                .test('typeOfAddressProvidedAtKRA', (value, context) => {
                  const {
                    options: { context: optionsContext },
                    path,
                    createError,
                  } = context;
                  if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                    return createError({
                      message: 'Please select type of address provided',
                      path,
                    });
                  }
                  return true;
                }),
            }
          ),

        // countryOfBirth: yup
        //   .string()
        //   .required('Please enter country of birth')
        //   .matches(stringRegex, 'Please enter country of birth'),

        // countryOfNationality: yup
        //   .string()
        //   .required('Please enter country of nationality')
        //   .matches(stringRegex, 'Please enter country of nationality'),

        taxIdResidentOfAnyCountryOtherThanIndia: yup
          .string()
          .nullable()
          .when('wishToUploadFatcaDocument', {
            is: (wishToUploadFatcaDocument: boolean) => !wishToUploadFatcaDocument,
            then: yup
              .string()
              .nullable()
              .test(
                'taxIdResidentOfAnyCountryOtherThanIndia',
                'Tax Resident of any other country is required',
                (value, context) => {
                  const {
                    options: { context: optionsContext },
                  } = context;
                  return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
                }
              ),
          }),
        taxCountryName: yup
          .string()
          .nullable()
          .when(
            ['taxIdResidentOfAnyCountryOtherThanIndia', 'wishToUploadFatcaDocument'],
            createSchemaForNonIndianResident(
              'taxCountryName',
              'Country of Tax Residency/TIN Issuing Country is required'
            )
          ),
        taxID: yup
          .string()
          // .max(20, 'Invalid Tax ID')
          .when(
            ['taxIdResidentOfAnyCountryOtherThanIndia', 'wishToUploadFatcaDocument'],
            createSchemaForNonIndianResident(
              'taxID',
              'Tax Identification Number (TIN)/Equivalent Number is required'
            )
          ),
        idType: yup
          .string()
          .when(
            ['taxIdResidentOfAnyCountryOtherThanIndia', 'wishToUploadFatcaDocument'],
            createSchemaForNonIndianResident('idType', 'ID Type is required')
          ),
        idTypeOthers: yup
          .string()
          .when(
            ['taxIdResidentOfAnyCountryOtherThanIndia', 'idType', 'wishToUploadFatcaDocument'],
            {
              is: (
                taxIdResidentOfAnyCountryOtherThanIndia: string | null,
                idType: string | null,
                wishToUploadFatcaDocument: boolean
              ) =>
                taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' &&
                idType === 'OTHERS' &&
                !wishToUploadFatcaDocument,
              then: yup
                .string()
                .nullable()
                .test('idTypeOthers', 'Please Specify ID Type', (value, context) => {
                  const {
                    options: { context: optionsContext },
                  } = context;
                  return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
                }),
            }
          ),
        tinNotAvailableReason: yup
          .string()
          .when(
            ['taxIdResidentOfAnyCountryOtherThanIndia', 'idType', 'wishToUploadFatcaDocument'],
            {
              is: (
                taxIdResidentOfAnyCountryOtherThanIndia: string | null,
                idType: string | null,
                wishToUploadFatcaDocument: boolean
              ) =>
                taxIdResidentOfAnyCountryOtherThanIndia === 'Yes' &&
                idType === 'OTHERS' &&
                !wishToUploadFatcaDocument,
              then: yup
                .string()
                .nullable()
                .test(
                  'tinNotAvailableReason',
                  'Reason (If TIN is not available) is required',
                  (value, context) => {
                    const {
                      options: { context: optionsContext },
                    } = context;
                    return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
                  }
                ),
            }
          ),

        usPerson: yup
          .string()
          .nullable()
          .when('wishToUploadFatcaDocument', {
            is: (wishToUploadFatcaDocument: boolean) =>
              !wishToUploadFatcaDocument &&
              !checkValidationBasedOnDate(createdAt, USPersonDateValidation),
            then: yup
              .string()
              .nullable()
              .test('usPerson', 'Field is required', (value, context) => {
                const {
                  options: { context: optionsContext },
                } = context;
                return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
              }),
          }),

        // nameOfEntity: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter name of entity')
        //   ),
        // dateOfIncorporation: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter date of incorporation')
        //   ),
        // cityOfIncorporation: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter city of incorporation')
        //   ),
        // countryOfIncorporation: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter country of incorporation')
        //   ),
        // entityExcemptionCode: yup
        //   .string()
        //   .when(
        //     'taxResidentOfAnyCountryOtherThanIndia',
        //     buildValidationSchema('Please enter entity exemption code')
        //   ),
      })
    ),
  });

export const adminSupportValidation = yup.object().shape({
  supportType: yup.string().required('Support Type is required'),
  application_number: yup
    .string()
    .nullable()
    .when('supportType', {
      is: (supportType: string) =>
        [
          adminSupportMaster.change_expired_status,
          adminSupportMaster.change_status_to_draft,
        ].includes(adminSupportMaster[supportType]),
      then: yup.string().required('Application Number is required'),
    }),
  status: yup
    .string()
    .nullable()
    .when('supportType', {
      is: (supportType: string) =>
        adminSupportMaster[supportType] === adminSupportMaster.change_expired_status,
      then: yup.string().required('Status is required'),
    }),
  phone: yup
    .string()
    .nullable()
    .when('supportType', {
      is: (supportType: string) =>
        ![
          adminSupportMaster.change_expired_status,
          adminSupportMaster.change_status_to_draft,
        ].includes(adminSupportMaster[supportType]),
      then: yup.string().test('phone', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        // if (parent.countryCode === 'India: +91' && !phoneRegExp.test(value)) {
        //   return createError({
        //     message: 'Invalid Mobile number',
        //     path,
        //   });
        // }
        if (
          !isValidPhoneNumber(
            parent?.countryCode?.split(':')[1].trim() + value,
            codesList as CountryCode
          )
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        return true;
      }),
    }),
  // .required('Mobile Number is required')
  // .min(8, 'Invalid mobile number')
  // .max(16, 'Invalid mobile number')
  // .matches(phoneRegExp, 'Invalid mobile number'),
  // countryCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.phone && !isValidPhoneNumber(parent.phone, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }
  //     return true;
  //   }),
});

export const nomineeDetailsSchema = (ifXalt?: boolean) =>
  yup.object().shape({
    nominees: yup.array().of(
      yup.object().shape({
        nomineeName: yup
          .string()
          .nullable()
          .matches(stringRegex, 'Special characters and numbers not allowed')
          .test('nomineeName', (value, context) => {
            const { path, createError, options } = context;
            if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
              return createError({
                message: 'Nominee Name is required',
                path,
              });
            }
            return true;
          }),
        nomineeRelationship: yup.string().when(['Relationship', 'isActive'], {
          is: (Relationship: string | null, isActive: boolean) =>
            isActive && Relationship === 'OTHERS' && !ifXalt,
          then: yup
            .string()
            .matches(stringRegex, 'Special characters and numbers not allowed')
            .test('nomineeRelationship', (value, context) => {
              const { path, createError, options } = context;
              if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Please Specify Relationship',
                  path,
                });
              }
              return true;
            }),
        }),
        Relationship: yup
          .string()
          .nullable()
          .oneOf(
            ifXalt ? NomineeRelationsXalt.concat(otherRelations) : NomineeRelations,
            'Invalid value for Nominee Relationship'
          )
          .test('Relationship', (value, context) => {
            const { path, createError, options } = context;
            if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
              return createError({
                message: 'Please select relationship',
                path,
              });
            }
            return true;
          }),
        dateOfBirth: yup
          .string()
          .nullable()
          .test('dateOfBirth', (value, context) => {
            const { path, createError, parent, options } = context;
            if (nomineeRelationForAgeMajor(parent.Relationship)) {
              if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Date of Birth is required',
                  path,
                });
              }
              if (value && !isMajor(value)) {
                return createError({
                  message: 'Date of birth should be greater than 18 years',
                  path,
                });
              }
            }
            return true;
          }),
        nomineePercentage: yup
          .number()
          .typeError('Nominee % should be a number')
          .test(
            'nomineePercentage',
            'Total Nominee % should be equal to 100%',
            (value, context) => {
              const {
                options: { context: optionsContext },
                path,
                createError,
              } = context;
              if (!value && value !== 0 && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                return createError({
                  message: 'Nominee % is required',
                  path,
                });
              }
              if (value === 0) {
                return createError({
                  message: 'Nominee % should be greater then 0',
                  path,
                });
              }
              const { nominees } = optionsContext || {};
              const total = nominees
                .map((nominee: NomineeType) => Number(nominee.nomineePercentage))
                .reduce((a: number, b: number) => a + b, 0);
              return nominees.length && total === 100;
            }
          ),
        guardianName: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'Relationship'], {
            is: (dateOfBirth: string | null, Relationship: string) =>
              !nomineeRelationForAgeMajor(Relationship) && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .test('guardianName', (value, context) => {
                const {
                  path,
                  createError,
                  options: { context: optionsContext },
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Guardian Name is required',
                    path,
                  });
                }
                return true;
              }),
          }),
        dateOfAttainingMajority: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'Relationship'], {
            is: (dateOfBirth: string | null, Relationship: string) =>
              !nomineeRelationForAgeMajor(Relationship) && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .test('dateOfAttainingMajority', (value, context) => {
                const fieldValue = value === undefined ? '' : value;
                const {
                  path,
                  createError,
                  parent,
                  options: { context: optionsContext },
                } = context;
                if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Date of Attaining Majority is required',
                    path,
                  });
                } else if (
                  fieldValue &&
                  parent.dateOfBirth &&
                  (new Date(parent.dateOfBirth).getDate() !== new Date(fieldValue).getDate() ||
                    new Date(parent.dateOfBirth).getMonth() !== new Date(fieldValue).getMonth() ||
                    new Date(parent.dateOfBirth).getFullYear() + 18 !==
                      new Date(fieldValue).getFullYear())
                ) {
                  return createError({
                    message: 'Invalid Date of Attaining Majority',
                    path,
                  });
                }
                return true;
              }),
          }),
        guardianAddress: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'Relationship'], {
            is: (dateOfBirth: string | null, Relationship: string) =>
              !nomineeRelationForAgeMajor(Relationship) && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .test('guardianAddress', (value, context) => {
                const {
                  path,
                  createError,
                  options: { context: optionsContext },
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Guardian Address is required',
                    path,
                  });
                }
                return true;
              }),
          }),
        guardianTaxIdNumber: yup
          .string()
          .nullable()
          .when(['dateOfBirth', 'Relationship'], {
            is: (dateOfBirth: string | null, Relationship: string) =>
              !nomineeRelationForAgeMajor(Relationship) && isMinor(dateOfBirth || ''),
            then: yup
              .string()
              .nullable()
              .test('guardianAddress', (value, context) => {
                const {
                  path,
                  createError,
                  options: { context: optionsContext },
                } = context;
                if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
                  return createError({
                    message: 'Guardian Country tax identification number is required',
                    path,
                  });
                }
                return true;
              }),
          }),
      })
    ),
  });

export const bankDetailsSchema = (
  applicants: Partial<Applicant>[] | undefined,
  ibanCountriesList: mdmsCountriesList[],
  createdAt: string,
  fundFlowType: string
) =>
  yup.object().shape({
    banks: yup.array().of(
      yup.object().shape({
        swiftCode: yup
          .string()
          .nullable()
          .test('swiftCode', (value, context) => {
            const {
              options: { context: optionsContext },
              parent,
              path,
              createError,
            } = context;
            if (
              !value &&
              shouldValidateUponSaveLater(optionsContext?.saveType) &&
              bankType[parent.investorBankType] === bankType.Overseas
            ) {
              return createError({
                message: 'SWIFT Code is required',
                path,
              });
            }
            return true;
          }),
        ifscCode: yup
          .string()
          .nullable()
          .matches(ifscRegex, 'Invalid IFSC Code')
          .test('ifscCode', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
              parent,
            } = context;
            if (
              !value &&
              shouldValidateUponSaveLater(optionsContext?.saveType) &&
              bankType[parent.investorBankType] === bankType.Domestic
            ) {
              return createError({
                message: 'IFSC Code is required',
                path,
              });
            }
            return true;
          }),
        bankAccountNumber: yup
          .string()
          .nullable()
          .matches(alphaNumeric, 'Special characters are not allowed')
          .test('bankAccountNumber', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Bank Account Number is required',
                path,
              });
            }
            return true;
          })
          .test('bankAccountNumber', 'Account number already used', (value, context) => {
            const {
              options: { context: optionsContext },
            } = context;
            const { banks } = optionsContext || {};
            return value
              ? banks.filter((bank: Bank) => bank.bankAccountNumber === value).length === 1
              : true;
          }),
        bankBranch: yup
          .string()
          .nullable()
          .test('bankBranch', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (
              !value &&
              shouldValidateUponSaveLater(optionsContext?.saveType) &&
              checkValidationBasedOnDate(createdAt, BankBranchMandatoryDate)
            ) {
              return createError({
                message: 'Bank Branch is required',
                path,
              });
            }
            return true;
          }),
        bankAccountType: yup
          .string()
          .nullable()
          .test('validBankAccountType', 'Invalid value for Account Type', function (value) {
            if (!value) return true;
            const { path, options } = this;
            const allowed = getBankAccountTypeMaster(
              createdAt,
              applicants?.[0]?.status,
              OUTBOUND_BANK_ACC_TYPE_CHANGE_DATE,
              INBOUND_BANK_ACC_TYPE_CHANGE_DATE,
              fundFlowType || '',
              this.parent?.investorBankType
            );
            return Object.keys(allowed).includes(value);
          })
          .test('bankAccountType', 'Bank Account Type is required', (value, context) => {
            const {
              options: { context: optionsContext },
            } = context;
            return shouldValidateUponSaveLater(optionsContext?.saveType) ? !!value : true;
          }),
        // .test('bankAccountType', 'Bank Account Type is required', (value, context) => {
        //   const {
        //     options: { context: optionsContext },
        //     createError,
        //     path,
        //     parent,
        //   } = context;
        //   const fieldValue = value === null ? '' : value;
        //   const { applicationType, status, banks } = optionsContext || {};
        //   if (
        //     applicationType === APPLICATION_TYPE.NON_INDIVIDUAL &&
        //     !['huf'].includes(applicants ? applicants[0]?.investorType || '' : '') &&
        //     !fieldValue
        //   ) {
        //     return true;
        //   }
        //   if (
        //     applicationType === APPLICATION_TYPE.NON_INDIVIDUAL &&
        //     fieldValue &&
        //     ![BankAccountTypeMaster.Current, BankAccountTypeMaster.Savings].includes(fieldValue)
        //   ) {
        //     return false;
        //   } else if (
        //     fieldValue &&
        //     applicantStatusMasters[status] !== applicantStatusMasters.NRI &&
        //     !Object.values(BankAccountTypeMaster).includes(fieldValue)
        //   ) {
        //     return false;
        //   }
        //   if (
        //     fieldValue &&
        //     applicantStatusMasters[status] === applicantStatusMasters.NRI &&
        //     !Object.values(NRIBankAccountTypeMaster).includes(fieldValue)
        //   ) {
        //     return false;
        //   }
        //   if (
        //     fieldValue &&
        //     applicantStatusMasters[status] === applicantStatusMasters.NRI &&
        //     banks.filter(
        //       (bank: Bank) =>
        //         Object.values(NRIBankAccountTypeMaster).includes(bank.bankAccountType) &&
        //         Object.values(NRIBankAccountTypeMaster).includes(fieldValue) &&
        //         bank.bankAccountType != fieldValue
        //     ).length === 1
        //   ) {
        //     return createError({
        //       message: 'Both Bank Account Type should be same',
        //       path,
        //     });
        //   }

        //   return !!fieldValue;
        // }),
        bankName: yup
          .string()
          .nullable()
          .test('bankName', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Bank Name is required',
                path,
              });
            }
            return true;
          }),
        // bankBranch: yup.string().nullable().required('Bank Branch is required'),
        bankAddress: yup
          .string()
          .nullable()
          .test('bankAddress', (value, context) => {
            const {
              options: { context: optionsContext },
              path,
              createError,
            } = context;
            if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
              return createError({
                message: 'Bank Address is required',
                path,
              });
            }
            return true;
          }),
        defaultBankAccount: yup
          .bool()
          .test('defaultBankAccount', 'Please check the default bank account', (value, context) => {
            const {
              options: { context: optionsContext },
            } = context;
            const { banks } = optionsContext || {};
            const isDefaultBankSelected = banks.some((bank: Bank) => bank.defaultBankAccount);
            return shouldValidateUponSaveLater(optionsContext?.saveType)
              ? isDefaultBankSelected
              : true;
          }),
        bankCountry: yup.string().nullable().required('Bank country is required'),

        ibanNumber: yup
          .string()
          .matches(alphaNumeric, 'Special characters are not allowed')
          .test('ibanNumber', `IBAN is required for this country`, function (value, context) {
            const {
              options: { context: optionsContext },
              parent,
            } = context;
            const BankCountry = this.parent?.bankCountry;
            if (
              isIbancountry(BankCountry, ibanCountriesList) &&
              bankType[parent.investorBankType] === bankType.Overseas
            ) {
              return !!value;
            }
            return true;
          }),
      })
    ),
  });

export const investmentPaymentDetailsSchema = (
  minCommitmentAmount: number,
  maxCommitmentAmount: number,
  minContributionPercentage: number,
  managementFee: number,
  currency: string | null,
  saveType: string,
  isPlacementFeeApplicable: string,
  placementFee: number | null | undefined,
  minPlacementFee: number | null | undefined,
  maxPlacementFee: number | null | undefined
) =>
  yup.object().shape({
    schemeId: yup.string().test('schemeId', 'Fund Scheme is required', (value, context) => {
      const { options } = context;
      return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
    }),
    planId: yup.string().when(['schemeId'], {
      is: (schemeId: string) => schemeId,
      then: yup.string().test('planId', 'Plan Type is required', (value, context) => {
        const { options } = context;
        return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
      }),
    }),
    commitmentAmount: yup
      .number()
      .nullable()
      .when(['schemeId', 'planId', 'applicationSource'], {
        is: (schemeId: string, planId: string, applicationSource: string) =>
          schemeId &&
          planId &&
          shouldValidateUponSaveLater(saveType) &&
          !folioValidationCheck(applicationSource),
        then: yup
          .number()
          .nullable()
          .min(
            minCommitmentAmount,
            `Capital Commitment should be greater than ${currencyConversion(
              minCommitmentAmount,
              currency
            )}`
          )
          .max(
            maxCommitmentAmount,
            `Capital Commitment should be between ${
              currencyConversion(minCommitmentAmount, currency) || '1 Cr'
            } and ${currencyConversion(maxCommitmentAmount, currency) || '2 Cr'}`
          )
          .test('commitmentAmount', 'Capital Commitment is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options.context?.saveType) &&
              !value &&
              !(value === 0)
              ? !!value
              : true;
          }),
      }),
    // contributionChequeAmount: yup
    //   .number()
    //   .nullable()
    //   .when('applicationSource', {
    //     is: (applicationSource: string) => !folioValidationCheck(applicationSource),
    //     then: yup
    //       .number()
    //       .nullable()
    //       .required(`Contribution Cheque Amount is required`)
    //       .max(
    //         yup.ref('commitmentAmount'),
    //         'Contribution Amount should not be greater than capital commitment'
    //       )
    //       .test(
    //         'contributionChequeAmount',
    //         `${
    //           Number(minContributionPercentage) === 100
    //             ? `Contribution Amount should be equal to capital commitment`
    //             : `Contribution Amount should be greater than or equal to ${minContributionPercentage}% of capital commitment`
    //         }`,
    //         (value, context) => {
    //           const { parent } = context;
    //           const { commitmentAmount } = parent;
    //           return (
    //             (100 * Number(value)) / Number(commitmentAmount) >=
    //             Number(minContributionPercentage)
    //           );
    //         }
    //       ),
    //   }),
    commitmentAmountForMigration: yup
      .string()
      .nullable()
      .when('applicationSource', {
        is: (applicationSource: string) => folioValidationCheck(applicationSource),
        then: yup
          .string()
          .nullable()
          .test(
            'commitmentAmountForMigration',
            'Capital Commitment is required',
            (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
            }
          ),
      }),
    placementFee: yup
      .number()
      .nullable()
      .test('placementFee', (val, context) => {
        const { path, createError, options, parent } = context;

        const value = val ?? null;
        const saveTypeCtx = options.context?.saveType;

        const applicable = isFieldApplicable(isPlacementFeeApplicable);
        const type = parent.placementFeeType; // "variable" | "fixed"

        const fixedFee = Number(placementFee);
        const minFee = Number(minPlacementFee ?? 0);
        const maxFee = Number(maxPlacementFee ?? 0);

        if (applicable && shouldValidateUponSaveLater(saveTypeCtx) && value === null) {
          return createError({
            path,
            message: 'Placement Fee is required',
          });
        }

        if (!applicable || !shouldValidateUponSaveLater(saveTypeCtx)) return true;

        if (isFieldTypeVariable(type)) {
          if (value !== null && (value < minFee || value > maxFee)) {
            return createError({
              path,
              message: `Placement Fee must be between ${minFee} and ${maxFee}`,
            });
          }
          return true;
        }

        if (isFieldTypeFixed(type)) {
          if (fixedFee === 0 && value !== 0) {
            return createError({
              path,
              message: `Placement Fee should be 0`,
            });
          }

          if (value !== null && (value < 0 || value > fixedFee)) {
            return createError({
              path,
              message: `Placement Fee should be between 0 and ${fixedFee}`,
            });
          }

          return true;
        }

        return true;
      }),

    // contributionAmountForMigration: yup
    //   .string()
    //   .nullable()
    //   .when('applicationSource', {
    //     is: (applicationSource: string) => folioValidationCheck(applicationSource),
    //     then: yup.string().nullable().required('Contribution Cheque Amount is required'),
    //   }),
    // managementFeesRate: yup
    //   .number()
    //   .nullable()
    //   .test(
    //     'managementFeesRate',
    //     `Management Fees Rate should be greater than or equal to 0% and less than or equal to ${Number(
    //       Number(managementFee) === 0 ? 100 : managementFee
    //     )}%`,
    //     (value, context) => {
    //       return value ? true : value === 0 ? true : false;
    //     }
    //   )
    //   .max(
    //     Number(Number(managementFee) === 0 ? 100 : managementFee),
    //     `Management Fees Rate should be less than or equal to ${
    //       Number(managementFee) === 0 ? 100 : managementFee
    //     }% `
    //   ),
  });

export const documentDetailsSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      documents: yup.array().of(
        yup.object().shape({
          documentsList: yup.array().of(
            yup.object().shape({
              documentName: yup
                .string()
                .nullable()
                .test(
                  'documentName',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, NonIndividualDocValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<NonIndividualDocValues> & { index: number };
                    const { applicants = [], banks } =
                      optionsContext || ({} as NonIndividualDocValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const {
                      required,
                      documentName,
                      documentType,
                      options: optionsDropdown,
                    } = applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    const fieldValue = optionsDropdown && value && optionsDropdown.includes(value);
                    if (
                      optionsDropdown &&
                      shouldValidateUponSaveLater(optionsContext?.saveType || '')
                    ) {
                      if (!fieldValue && required === 'true') {
                        return createError({
                          message: `Please Select ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              documentId: yup
                .string()
                .nullable()
                .test(
                  'documentId',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, NonIndividualDocValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<NonIndividualDocValues> & { index: number };
                    const { applicants = [], banks } =
                      optionsContext || ({} as NonIndividualDocValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const { required, documentName, documentType } =
                      applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    if (required === 'false') {
                      return true;
                    }
                    if (!value && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                      if (!value && required === 'true') {
                        return createError({
                          message: `Please upload ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
            })
          ),
        })
      ),
    })
  ),
  nominees: yup.array().of(
    yup.object().shape({
      nomineedocuments: yup.array().of(
        yup.object().shape({
          documentsList: yup.array().of(
            yup.object().shape({
              documentName: yup
                .string()
                .nullable()
                .test(
                  'documentName',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, DocumentValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<DocumentValues> & { index: number };
                    const { nominees = [] } = optionsContext || ({} as DocumentValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const {
                      required,
                      documentName,
                      documentType,
                      options: optionsDropdown,
                    } = nominees[indexes[0]].nomineedocuments[indexes[1]].documentsList[indexes[2]];
                    const fieldValue = optionsDropdown && value && optionsDropdown.includes(value);
                    if (
                      optionsDropdown &&
                      shouldValidateUponSaveLater(optionsContext?.saveType || '')
                    ) {
                      if (!fieldValue && required === 'true') {
                        return createError({
                          message: `Please Select ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              documentId: yup
                .string()
                .nullable()
                .test(
                  'documentId',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, DocumentValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<DocumentValues> & { index: number };
                    const { nominees = [], banks } = optionsContext || ({} as DocumentValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const { required, documentName, documentType } =
                      nominees[indexes[0]].nomineedocuments[indexes[1]].documentsList[indexes[2]];
                    if (required === 'false') {
                      return true;
                    }
                    if (
                      !value &&
                      required === 'true' &&
                      shouldValidateUponSaveLater(optionsContext?.saveType || '')
                    ) {
                      return createError({
                        message: `Please upload ${documentName}`,
                        path,
                      });
                    }
                    return true;
                  }
                ),
            })
          ),
        })
      ),
    })
  ),
  documentDeclarationCheck: yup
    .boolean()
    .nullable()
    .test('documentDeclarationCheck', (value, context) => {
      const fieldValue = value === null ? '' : value;
      const {
        createError,
        path,
        options: { context: optionsContext },
      } = context;
      if (!fieldValue && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
        return createError({
          message: 'Acknowledgement is required',
          path,
        });
      }
      return true;
    }),
  // applicants: yup.array().of(
  //   yup.object().shape({
  //     documents: yup.object().shape({
  //       // identityProof: yup.object().shape({
  //       //   documentName: yup.string().required('Please select identity proof'),
  //       //   documentId: yup.string().required('Please upload Identity Proof'),
  //       // }),
  //       // addressProof: yup.object().shape({
  //       //   documentName: yup.string().required('Please select Address Proof'),
  //       //   documentId: yup.string().required('Please upload Address Proof'),
  //       // }),
  //       bankAccountProof: yup.object().shape({
  //         documentName: yup
  //           .string()
  //           .test('documentName', 'Please select Bank Account Proof', (value, context) =>
  //             DocumentRequiredForPennyDrop(value, context)
  //           ),

  //         documentId: yup
  //           .string()
  //           .test('documentId', 'Please upload Bank Account Proof', (value, context) =>
  //             DocumentRequiredForPennyDrop(value, context)
  //           ),
  //       }),
  //       poaNotarized: yup.object().shape({
  //         documentId: yup
  //           .string()
  //           .test('documentId', 'Please upload POA Notarized Document', (value, context) =>
  //             POADocumentValidation(value, context, 'poaNotarized')
  //           ),
  //       }),
  //       investorsConsent: yup.object().shape({
  //         documentId: yup
  //           .string()
  //           .test('documentId', "Please upload Investor's Consent Document", (value, context) =>
  //             POADocumentValidation(value, context)
  //           ),
  //       }),
  //       fatca: yup.object().shape({
  //         documentId: yup
  //           .string()
  //           .test('documentId', 'Please upload FATCA Document', (value, context) =>
  //             POADocumentValidation(value, context)
  //           ),
  //       }),
  //     }),
  //   })
  // ),
});

export const distributorsValidationSchema = (
  selectedDistributor: SubDistributor[],
  selectSupport: SubDistributor[],
  distributors: Distributor[]
) =>
  yup.object().shape({
    //role: useSelector((store: RootStateType) => store.auth),
    distributorId: yup
      .string()
      .nullable()
      .when('loginType', {
        is: (loginType: string) => loginType === 'distributor' && !!distributors.length,
        then: yup.string().nullable().required('Please select a distributor code'),
      }),
    subdistributorId: yup
      .string()
      .nullable()
      .when(['loginType', 'distributorId'], {
        is: (loginType: string) => loginType === 'distributor' && !!selectedDistributor.length,
        then: yup.string().nullable().required("Please select a distributor's rm name - code"),
      }),
    // supportSubdistributorId: yup
    //   .string()
    //   .nullable()
    //   .when(['loginType'], {
    //     is: (loginType: string) => loginType === 'distributor' && !!selectSupport.length,
    //     then: yup.string().nullable().required('Please select a CSE name'),
    //   }),
    subBrokerCode: yup
      .string()
      .nullable()
      .when(['loginType', 'distributorId'], {
        is: (loginType: string, distributorId: number) =>
          loginType === 'distributor' && !!distributorId,
        then: (schema) =>
          schema
            .matches(alphaNumeric, 'Sub-broker code must be alphanumeric')
            .max(20, 'Sub-broker code must be at most 20 characters'),
      }),
  });

export const userManagementRmSchema = yup.object().shape({
  name: yup.string().nullable().required('RM Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .min(8, 'Invalid Phone number')
  //   .max(16, 'Invalid Phone number')
  //   .matches(phoneRegExp, 'Invalid Phone number')
  //   .required('Phone Number is required'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Phone Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Phone number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Phone number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Phone Number',
          path,
        });
      }

      return true;
    }),
});

export const DistributorSchema = yup.object().shape({
  name: yup.string().nullable().required('Distributor Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .test('email', (value, context) => {
      const { createError, path, parent } = context;

      if (!value && parent.type === 'individual') {
        return createError({
          message: 'Email is required',
          path,
        });
      }

      if (parent.type === 'company') {
        if (parent.phone && !value) {
          return createError({
            message: 'Email is required',
            path,
          });
        }
      }

      return true;
    }),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .min(8, 'Invalid Contact number')
  //   .max(16, 'Invalid Contact number')
  //   .matches(phoneRegExp, 'Invalid Contact number')
  //   .when('type', {
  //     is: (value: string) => value === 'individual',
  //     then: yup.string().nullable().required('Contact Number is required'),
  //   }),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value && parent.type === 'individual') {
        return createError({
          message: 'Contact Number is required',
          path,
        });
      }
      if (parent.type === 'company') {
        if (parent.email && !value) {
          return createError({
            message: 'Contact Number is required',
            path,
          });
        }
      }
      // if (
      //   value &&
      //   parent.type === 'individual' &&
      //   parent.countryNameAndCode === 'India: +91' &&
      //   !phoneRegExp.test(value)
      // ) {
      //   return createError({
      //     message: 'Invalid Contact number',
      //     path,
      //   });
      // }
      if (
        value &&
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Contact number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value && parent.type === 'individual') {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        value &&
        parent.type === 'individual' &&
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Contact number',
          path,
        });
      }

      return true;
    }),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // arnCode: yup.string().nullable().matches(arnCodeRegex, 'Invalid Distributor Code Ex:- Distributor-12345'),
  // .required('Distributor Code is required'),
  rmId: yup
    .string()
    .nullable()
    .when('type', {
      is: (value: string) => value === 'individual',
      then: yup.string().nullable().required('RM Name is required'),
    }),
  schemeAndPlan: yup.array().of(
    yup.object().shape({
      planIds: yup
        .array()
        .nullable()
        .when('schemeIds', {
          is: (schemeIds: number | string) => schemeIds !== null,
          then: yup
            .array()
            .nullable()
            .min(1, 'Please choose applicable Plans')
            .required('Please choose applicable Plans'),
        }),
    })
  ),
  // pincode: yup.string().nullable().required('Please Enter Pincode'),
  // buildingNo: yup.string().nullable().required('Please Enter Building Number'),
  // streetName: yup.string().nullable().required('Please Enter Street Name'),
  // city: yup.string().nullable().required('Please Enter City'),
  // state: yup.string().nullable().required('Please Enter State'),
  // country: yup.string().nullable().required('Please Enter Country'),
});

export const TrusteeAndFundManagerSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .required('Mobile Number is required')
  //   .min(8, 'Invalid Mobile number')
  //   .max(16, 'Invalid Mobile number')
  //   .matches(phoneRegExp, 'Invalid Mobile number'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Mobile Number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile Number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  dateOfBirth: yup
    .string()
    .nullable()
    .test(
      'dateOfBirth',
      'Age should be greater than 18',
      (dateOfBirth) => !isMinor(dateOfBirth || '')
    ),
  leegalityName: yup.string().nullable().required('Leegality Name is required'),
  // .required('Date of Birth is required'),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // pincode: yup.string().required('Please Enter Pincode'),
  // buildingNo: yup.string().required('Please Enter Building Number'),
  // streetName: yup.string().required('Please Enter Street Name'),
  // city: yup.string().required('Please Enter City'),
  // state: yup.string().required('Please Enter State'),
  // country: yup.string().required('Please Enter Country'),
});

export const aifApproverSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .required('Mobile Number is required')
  //   .min(8, 'Invalid Mobile Number')
  //   .max(16, 'Invalid Mobile Number')
  //   .matches(phoneRegExp, 'Invalid Mobile Number'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Mobile Number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile Number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  // pincode: yup.string().required('Please Enter Pincode'),
  // buildingNo: yup.string().required('Please Enter Building Number'),
  // streetName: yup.string().required('Please Enter Street Name'),
  // city: yup.string().required('Please Enter City'),
  // state: yup.string().required('Please Enter State'),
  // country: yup.string().required('Please Enter Country'),
});

export const addFundManagerSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .required('Mobile Number is required')
  //   .min(8, 'Invalid mobile number')
  //   .max(16, 'Invalid mobile number')
  //   .matches(phoneRegExp, 'Invalid mobile number'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Mobile number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  leegalityName: yup.string().nullable().required('Leegality Name is required'),
  // pincode: yup.string().required('Please Enter Pincode'),
  // buildingNo: yup.string().required('Please Enter Building Number'),
  // streetName: yup.string().required('Please Enter Street Name'),
  // city: yup.string().required('Please Enter City'),
  // state: yup.string().required('Please Enter State'),
  // country: yup.string().required('Please Enter Country'),
});

export const AuthorisedSignatoryAndPOASchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .min(8, 'Invalid Mobile number')
  //   .max(16, 'Invalid Mobile number')
  //   .matches(phoneRegExp, 'Invalid Mobile number')
  //   .required('Mobile Number is required'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Mobile number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // distributorId: yup.string().required('Please Enter Distridutor Id'),
  // amcId: yup.string().required('Please Enter AmcId'),
  // pincode: yup.string().nullable().required('Please Enter Pincode'),
  // buildingNo: yup.string().nullable().required('Please Enter Building Number'),
  // streetName: yup.string().nullable().required('Please Enter Street Name'),
  // city: yup.string().nullable().required('Please Enter City'),
  // state: yup.string().nullable().required('Please Enter State'),
  // country: yup.string().nullable().required('Please Enter Country'),
});

export const DistributorRmSchema = yup.object().shape({
  name: yup.string().nullable().required("Distributor's RM name is required"),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .min(8, 'Invalid Contact number')
  //   .max(16, 'Invalid Contact number')
  //   .matches(phoneRegExp, 'Invalid Contact number')
  //   .required('Contact Number is required'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Contact Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Contact number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Contact number',
          path,
        });
      }

      return true;
    }),
  subdistributorType: yup
    .string()
    .nullable()
    .oneOf(Object.keys(subdistributorTypes), 'Invalid value for Subdistributor Type')
    .required('Please Select Subdistributor Type'),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Contact number',
          path,
        });
      }

      return true;
    }),
  //distributors_RM_Code: yup.string().required('Please Enter Distributor RM code'),
  rmId: yup.string().nullable(),
  // panNumber: yup
  //   .string()
  //   .uppercase()
  //   .length(10, 'PAN must be exactly 10 characters')
  //   .matches(individualPanRegex, 'Only individual PANs are allowed currently')
  //   .required('PAN is required'),
  // pincode: yup.string().nullable().required('Please Enter Pincode'),
  // buildingNo: yup.string().nullable().required('Please Enter Building Number'),
  // streetName: yup.string().nullable().required('Please Enter Street Name'),
  // city: yup.string().nullable().required('Please Enter City'),
  // state: yup.string().nullable().required('Please Enter State'),
  // country: yup.string().nullable().required('Please Enter Country'),
});

// name,
// email,
// countryCode,
// phone,
// panNumber,
// distributors_RM_Code,
// rmId,
// distributorId,
// pincode,
// buildingNo,
// streetName,
// city,
// state,
// country,

// pan: yup
// .string()
// .nullable()
// .uppercase()
// .length(10, 'PAN must be exactly 10 characters')
// .matches(individualPanRegex, 'Only individual PANs are allowed')
// .test('pan', (value, context) => {
//   const { path, createError, options } = context;
//   const { context: optionsContext } = options as InternalOptions<Groups[]>;
//   const authorisedSignatoriesPanNumbers = optionsContext
//     ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.pan))
//     .flat();
//   if (!value) {
//     return createError({
//       message: 'PAN is required',
//       path,
//     });
//   }
//   if (authorisedSignatoriesPanNumbers && authorisedSignatoriesPanNumbers.includes(value)) {
//     return createError({
//       message:
//         'There is already same pan number for an Authorised Signatory associated with this application',
//       path,
//     });
//   }

//   return true;
// }),

// mobile: yup
// .string()
// .nullable()
// .min(8, 'Invalid Mobile Number')
// .max(16, 'Invalid Mobile Number')
// .matches(phoneRegExp, 'Invalid Mobile Number')
// .test('mobile', (value, context) => {
//   const { path, createError, options } = context;
//   const { context: optionsContext } = options as InternalOptions<Groups[]>;
//   const authorisedSignatoriesMobileNumbers = optionsContext
//     ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.mobile))
//     .flat();
//   if (!value) {
//     return createError({
//       message: 'Mobile Number is required',
//       path,
//     });
//   }
//   if (
//     authorisedSignatoriesMobileNumbers &&
//     authorisedSignatoriesMobileNumbers.includes(value)
//   ) {
//     return createError({
//       message:
//         'There is already same mobile number for an Authorised Signatory associated with this application',
//       path,
//     });
//   }

//   return true;
// }),
// email: yup
// .string()
// .nullable()
// .matches(emailRegex, 'invalid Email ID')
// .test('email', (value, context) => {
//   const { path, createError, options } = context;
//   const { context: optionsContext } = options as InternalOptions<Groups[]>;
//   const authorisedSignatoriesEmailID = optionsContext
//     ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.email))
//     .flat();
//   if (!value) {
//     return createError({
//       message: 'Email ID is required',
//       path,
//     });
//   }
//   if (authorisedSignatoriesEmailID && authorisedSignatoriesEmailID.includes(value)) {
//     return createError({
//       message:
//         'There is already same Email ID for an Authorised Signatory associated with this application',
//       path,
//     });
//   }

//   return true;
// }),
export const amcAdminSchema = yup.object().shape({
  name: yup.string().nullable().required('Name is required'),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid email id')
    .required('Email is required'),
  // phone: yup
  //   .string()
  //   .nullable()
  //   .required('Mobile Number is required')
  //   .min(8, 'Invalid Mobile Number')
  //   .max(16, 'Invalid Mobile Number')
  //   .matches(phoneRegExp, 'Invalid Mobile Number'),
  phone: yup
    .string()
    .nullable()
    .test('phone', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === parent.countryNameAndCode) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Mobile Number is required',
          path,
        });
      }
      // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
      //   return createError({
      //     message: 'Invalid Mobile Number',
      //     path,
      //   });
      // }
      if (
        !isValidPhoneNumber(
          parent?.countryNameAndCode?.split(':')[1].trim() + value,
          codesList as CountryCode
        )
      ) {
        return createError({
          message: 'Invalid Mobile Number',
          path,
        });
      }

      return true;
    }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      if (
        parent.phone &&
        !isValidPhoneNumber(value?.split(':')[1].trim() + parent.phone, codesList as CountryCode)
      ) {
        return createError({
          message: 'Invalid Mobile number',
          path,
        });
      }

      return true;
    }),
});

export const NonIndividualContributorValidationSchema = (ifXalt: boolean) =>
  yup.object().shape({
    folio_no: yup
      .string()
      .nullable()
      .when('applicationSource', {
        is: (applicationSource: string) => folioValidationCheck(applicationSource),
        then: yup
          .string()
          .nullable()
          .matches(alphaNumeric, 'Special characters are not allowed')
          .test('folio_no', 'Folio Number is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
      }),
    applicants: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .nullable()
          .test('name', 'Name Of Entity is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        cityOfIncorporation: yup
          .string()
          .nullable()
          .test(
            'cityOfIncorporation',
            'Place of Registration/Incorporation is required',
            (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
            }
          ),
        dateOfBirth: yup
          .string()
          .nullable()
          .test(
            'dateOfBirth',
            'Date of Registration/Incorporation is required',
            (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
            }
          ),
        taxIdNumber: yup
          .string()
          .nullable()
          .test('taxIdNumber', 'Tax ID is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        pan: yup
          .string()
          .nullable()
          .when('panDeclaration', {
            is: (panDeclaration: boolean) => !panDeclaration,
            then: yup
              .string()
              .nullable()
              .uppercase()
              .length(10, 'PAN must be exactly 10 characters')
              .test('pan', (value, context) => {
                const fieldValue = value === undefined ? '' : value;
                const { path, createError, parent } = context;
                if (!fieldValue) {
                  return createError({
                    message: 'PAN is required',
                    path,
                  });
                }
                if (!nonIndividualPanRegex.test(fieldValue)) {
                  return createError({
                    message: 'Only Non individual PANs are allowed',
                    path,
                  });
                }
                return true;
              }),
          }),
        lawType: yup
          .string()
          .nullable()
          .required('Law Under Which Formed/Incorporated is required'),
        // panNo: yup
        //   .string()
        //   .nullable()
        //   .uppercase()
        //   .length(10, 'PAN must be exactly 10 characters')
        //   .matches(nonIndividualPanRegex, 'invalid PAN')
        //   .required('PAN is required'),
        investorType: yup
          .string()
          .nullable()
          .oneOf(Object.keys(investorTypeMasters), 'Invalid value for Investor Type')
          .test('investorType', 'Please Select Investor Type', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        netWorth: yup
          .string()
          .nullable()
          .test('netWorth', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError } = context;
            if (fieldValue && !numberRegex.test(fieldValue)) {
              return createError({
                message: 'Invalid amount',
                path,
              });
            }
            return true;
          }),
        grossAnnualIncome: yup
          .string()
          .nullable()
          .test('grossAnnualIncome', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, options } = context;
            if (fieldValue && !grossAnnualMasters['foreign'].includes(fieldValue)) {
              return createError({
                message: 'Invalid value for Gross Annual Income',
                path,
              });
            }
            return true;
          }),
        politicallyExposedPersonStatus: yup
          .string()
          .oneOf(PEPsMasters, 'Invalid value for PEP Status')
          .test('politicallyExposedPersonStatus', 'PEP status is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        relationshipWithPep: yup
          .string()
          .nullable()
          .when('politicallyExposedPersonStatus', {
            is: (politicallyExposedPersonStatus: string) =>
              checkRelationshipWithPep(politicallyExposedPersonStatus),
            then: yup
              .string()
              .nullable()
              .test('relationshipWithPep', (value, context) => {
                const { path, createError, parent, options } = context;
                if (!value && shouldValidateUponSaveLater(options?.context?.saveType)) {
                  return createError({
                    message: `${getRelationshipWithPepLabel(
                      parent.politicallyExposedPersonStatus
                    )}  is required`,
                    path,
                  });
                }
                return true;
              }),
          }),
      })
    ),
  });

export const NonIndividualContributorValidationSchemaWithPan = (
  createdAt: string,
  ifXalt: boolean
) =>
  // brokers: Broker[],
  //createdAt: string
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        name: yup
          .string()
          .nullable()
          .test('name', 'Name Of Entity is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        cityOfIncorporation: yup
          .string()
          .nullable()
          .test(
            'cityOfIncorporation',
            'Place of Registration/Incorporation is required',
            (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
            }
          ),
        countryOfIncorporation: yup
          .string()
          .nullable()
          .test(
            'countryOfIncorporation',
            'Country of Incorporation is required',
            (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options?.context?.saveType) &&
                IsOutBoundFundFlow(options?.context?.fundFlowType)
                ? !!value
                : true;
            }
          ),
        dateOfBirth: yup
          .string()
          .nullable()
          .test(
            'dateOfBirth',
            'Date of Registration/Incorporation is required',
            (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
            }
          ),
        lawType: yup
          .string()
          .nullable()
          .required('Law Under Which Formed/Incorporated is required'),
        // dlclId: yup
        //   .string()
        //   .nullable()
        //   .test('dlclId', (value, context) => {
        //     const {
        //       path,
        //       createError,
        //       options: { context: optionsContext },
        //     } = context;
        //     if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
        //       return createError({
        //         message: `Demat Account Details (for allotment of units) is required`,
        //         path,
        //       });
        //     }
        //     if (value && !Object.keys(DLCLMasters).includes(value)) {
        //       return createError({
        //         message: 'Invalid value for Demat Account Details (for allotment of units)',
        //         path,
        //       });
        //     }
        //     return true;
        //   }),
        // dpId: yup
        //   .string()
        //   .nullable()
        //   .when('dlclId', {
        //     is: (dlclId: string) => getdpIdField(dlclId || ''),
        //     then: yup
        //       .string()
        //       .nullable()
        //       .test('dpId', (value, context) => {
        //         const { path, createError, parent, options } = context;
        //         if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
        //           return createError({
        //             message: `${isCDSL(parent.dlclId) ? 'DPCL ID' : 'DP ID'} is required`,
        //             path,
        //           });
        //         }
        //         if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
        //           if (value && !isCDSL(parent.dlclId) && !dpIdRegex.test(value)) {
        //             return createError({
        //               message: `DP ID should consist of 8 digits and must start with 'IN'`,
        //               path,
        //             });
        //           }

        //           if (value && isCDSL(parent.dlclId)) {
        //             if (
        //               !dpIdNumberRegex.test(value) &&
        //               checkValidationBasedOnDate(createdAt, dpIdFieldValidationDate)
        //             ) {
        //               return createError({
        //                 message: 'DPCL ID should consist of 16 numeric digits',
        //                 path,
        //               });
        //             }
        //             if (
        //               !checkValidationBasedOnDate(createdAt, dpIdFieldValidationDate) &&
        //               !(cdslRegex.test(value) || dpIdNumberRegex.test(value))
        //             ) {
        //               return createError({
        //                 message: 'DPCL ID should consist of 8 or 16 numeric digits',
        //                 path,
        //               });
        //             }
        //             return true;
        //           }
        //           return true;
        //         }
        //         return true;
        //       }),
        //   }),
        // clId: yup
        //   .string()
        //   .nullable()
        //   .when('dlclId', {
        //     is: (dlclId: string) => getclIdField(dlclId || ''),
        //     then: yup
        //       .string()
        //       .nullable()
        //       .test('clId', (value, context) => {
        //         const { path, createError, options } = context;
        //         if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
        //           return createError({
        //             message: 'CL ID is required',
        //             path,
        //           });
        //         }
        //         if (checkValidationBasedOnDate(createdAt, dematFieldValidationDate)) {
        //           if (value && !cdslRegex.test(value)) {
        //             return createError({
        //               message: 'CL ID should consist of 8 numeric digits',
        //               path,
        //             });
        //           }
        //         }
        //         return true;
        //       }),
        //   }),
        // nameOfBroker: yup
        //   .string()
        //   .nullable()
        //   .when('dlclId', {
        //     is: (dlclId: string) => getdpIdField(dlclId || ''),
        //     then: yup
        //       .string()
        //       .nullable()
        //       .test('nameOfBroker', (value, context) => {
        //         const { path, createError } = context;
        //         const brokerList = brokers.map((broker) => broker.key);
        //         if (!value) {
        //           return true;
        //         }
        //         if (value && !brokerList.includes(value)) {
        //           return createError({
        //             message: 'Invalid value for Name of Broker/Depository Participant (DP)',
        //             path,
        //           });
        //         }
        //         return true;
        //       }),
        //   }),
        // otherNameOfBroker: yup
        //   .string()
        //   .nullable()
        //   .when(['dlclId', 'nameOfBroker'], {
        //     is: (dlclId: string, nameOfBroker: string) =>
        //       getdpIdField(dlclId || '') && otherNameOfBroker(nameOfBroker),
        //     then: yup
        //       .string()
        //       .nullable()
        //       .test('otherNameOfBroker', (value, context) => {
        //         const {
        //           path,
        //           createError,
        //           options: { context: optionsContext },
        //         } = context;
        //         if (!value && shouldValidateUponSaveLater(optionsContext?.saveType)) {
        //           return createError({
        //             message: 'Other Name of Broker is required',
        //             path,
        //           });
        //         }
        //         return true;
        //       }),
        //   }),
        ckycNo: yup
          .string()
          .nullable()
          .test('ckycNo', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const {
              options: { context: optionsContext },
              createError,
              path,
              parent,
            } = context;
            const { applicants } = optionsContext || {};
            if (!fieldValue) {
              return true;
            } else if (!ckycNumberRegex.test(fieldValue as string) && !parent.maskedCkycNo) {
              return createError({
                message: 'Invalid CKYC No./CKYC Acknowledge No./KIN No',
                path,
              });
              // } else if (!numberRegex.test(fieldValue)) {
              //   return createError({
              //     message: 'CKYC No./CKYC Acknowledge No./KIN No allows only digits',
              //     path,
              //   });
            }
            // else if (
            //   applicants.filter((applicant: Applicant) => applicant.ckycNo === fieldValue).length >
            //   1
            // ) {
            //   return createError({
            //     message:
            //       'There is already same CKYC Number for an applicant associated with this application',
            //     path,
            //   });
            // }
            return true;
          }),
        panNo: yup
          .string()
          .nullable()
          .uppercase()
          .length(10, 'PAN must be exactly 10 characters')
          .matches(nonIndividualPanRegex, 'Invalid PAN')
          .test('panNo', 'PAN is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        investorType: yup
          .string()
          .nullable()
          // .oneOf(Object.keys(investorTypeOutboundMasters), 'Invalid value for Investor Type')
          .test('investorType', 'Please Select Investor Type', (value, context) => {
            const { options, path, createError } = context;
            if (
              !Object.keys(
                IsOutBoundFundFlow(options?.context?.fundFlowType)
                  ? investorTypeOutboundMasters
                  : investorTypeMasters
              ).includes(value || '')
            ) {
              return createError({
                message: 'Invalid value for Investor Type',
                path,
              });
            }
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        netWorth: yup
          .string()
          .nullable()
          .test('netWorth', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, options } = context;
            if (
              !fieldValue &&
              shouldValidateUponSaveLater(options?.context?.saveType) &&
              !IsOutBoundFundFlow(options?.context?.fundFlowType)
            ) {
              return createError({
                message: 'Net Worth is required',
                path,
              });
            }
            if (fieldValue && !amountRegex.test(fieldValue)) {
              return createError({
                message: 'Invalid amount',
                path,
              });
            }
            return true;
          }),
        netWorthDate: yup
          .string()
          .nullable()
          .test('netWorthDate', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent, options } = context;
            const selected = new Date(value ?? '');
            const minAllowedDate = minNetworthDate(createdAt);
            if (IsOutBoundFundFlow(options?.context?.fundFlowType)) {
              if (selected < minAllowedDate) {
                return createError({
                  path,
                  message: `Net worth date cannot be older than ${
                    minAllowedDate.toISOString().split('T')[0]
                  }`,
                });
              }
              // if (!fieldValue && shouldValidateUponSaveLater(options?.context?.saveType)) {
              //   return createError({
              //     message: 'Net Worth Date is required',
              //     path,
              //   });
              // }
            }
            return true;
          }),
        grossAnnualIncome: yup
          .string()
          .nullable()
          .test('grossAnnualIncome', 'Gross Annual Income is required', (value, context) => {
            const { options, path, createError } = context;
            if (value && !grossAnnualMasters['foreign'].includes(value)) {
              return createError({
                message: 'Invalid value for Gross Annual Income',
                path,
              });
            }
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        politicallyExposedPersonStatus: yup
          .string()
          .oneOf(PEPsMasters, 'Invalid value for PEP Status')
          .test('politicallyExposedPersonStatus', 'PEP status is required', (value, context) => {
            const { options } = context;
            return shouldValidateUponSaveLater(options?.context?.saveType) ? !!value : true;
          }),
        relationshipWithPep: yup
          .string()
          .nullable()
          .when('politicallyExposedPersonStatus', {
            is: (politicallyExposedPersonStatus: string) =>
              checkRelationshipWithPep(politicallyExposedPersonStatus),
            then: yup
              .string()
              .nullable()
              .test('relationshipWithPep', (value, context) => {
                const { path, createError, parent, options } = context;
                if (!value && shouldValidateUponSaveLater(options?.context?.saveType)) {
                  return createError({
                    message: `${getRelationshipWithPepLabel(
                      parent.politicallyExposedPersonStatus
                    )}  is required`,
                    path,
                  });
                }
                return true;
              }),
          }),
        isServicesRequired: yup
          .array()
          .nullable()
          .test('isServicesRequired', 'Plaese Select atleast one', (value, context) => {
            const fieldValue = value ?? [];
            const { options, createError, path, parent } = context;
            if (IsOutBoundFundFlow(options?.context?.fundFlowType)) {
              if (!fieldValue?.length) {
                return createError({
                  message: 'Please select a value',
                  path,
                });
              }
              if (fieldValue.length > 1 && fieldValue.includes('isNoneOfThese')) {
                return createError({
                  message: 'When selecting "None of these" multiple selections are not permitted',
                  path,
                });
              }
              return true;
            }
            return true;
          }),
      })
    ),
  });

const validateNonIndividualPincodeField = (
  value: string | null | undefined,
  context: yup.TestContext<Record<string, Values>>,
  addressType: string
) => {
  const fieldValue = value === undefined ? '' : value;
  const { options, path, createError, parent } = context;
  const { context: optionsContext, index } =
    options as InternalOptions<NonIndividualContactValues> & {
      index: number;
    };
  const { applicants = [] } = optionsContext || {};
  if (!fieldValue) {
    return true;
  }
  if (fieldValue && parent.country?.toLowerCase() === 'india' && !indianPin.test(fieldValue)) {
    return createError({
      message: 'Pincode code should be 6 digit code',
      path,
    });
  }
  if (fieldValue && parent.country?.toLowerCase() !== 'india' && !alphaNumeric.test(fieldValue)) {
    return createError({
      message: 'Invalid Pincode',
      path,
    });
  }
  return true;
};

export const nonIndividualContactDetailsSchemaWithPan = (flowType = '') =>
  yup.object().shape({
    applicants: yup.array().of(
      yup.object().shape({
        contactperson: yup.object().shape({
          address1: yup
            .string()
            .nullable()
            .matches(
              addressRegex,
              "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
            ),
          // .required('Address line 1 is required'),
          address2: yup
            .string()
            .nullable()
            .matches(
              addressRegex,
              "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
            ),
          // .required('Address line 2 is required'),

          landLineNumber: yup
            .string()
            .nullable()
            .test('landLineNumber', (value, context) => {
              const fieldValue = value === undefined ? '' : value;
              const { path, createError, parent, options } = context;
              if (
                !fieldValue &&
                parent.stdCode &&
                shouldValidateUponSaveLater(options.context?.saveType)
              ) {
                return createError({
                  message: 'Please enter Landline number',
                  path,
                });
              } else if (parent.landLineNumber && !numberRegex.test(parent.landLineNumber)) {
                return createError({
                  message: 'Please enter valid Landline Number',
                  path,
                });
              }
              return true;
            }),
          stdCode: yup
            .string()
            .nullable()
            .test('stdCode', (value, context) => {
              const fieldValue = value === undefined ? '' : value;
              const { path, createError, parent, options } = context;
              if (
                !fieldValue &&
                parent.landLineNumber &&
                shouldValidateUponSaveLater(options.context?.saveType)
              ) {
                return createError({
                  message: 'Please enter STD Code',
                  path,
                });
              } else if (parent.stdCode && !numberRegex.test(parent.stdCode)) {
                return createError({
                  message: 'Please enter valid STD Code',
                  path,
                });
              }
              return true;
            }),

          city: yup.string().nullable(),
          // .required('City is required'),
          state: yup
            .string()
            .nullable()
            .test('state', (value, context) => {
              const { path, createError, parent, options } = context;
              const { context: optionsContext } = options;
              const fieldValue = value === undefined ? '' : value;
              const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
              if (
                fieldValue &&
                !isIndia &&
                shouldValidateUponSaveLater(optionsContext?.saveType) &&
                !stateRegexOtherThanIndia.test(fieldValue as string)
              ) {
                return createError({
                  message: 'Invalid State',
                  path,
                });
              }
              return true;
            }),
          // .required('State is required'),
          country: yup
            .string()
            .nullable()
            .test('country', (value, context) => {
              const { options, createError, path } = context;
              const { context: optionsContext } =
                options as InternalOptions<NonIndividualContactValues>;
              const { countryDropdown = [] } = optionsContext || {};
              // if (!value) {
              //   return createError({
              //     message: 'Country is required',
              //     path,
              //   });
              // }
              if (value && !countryDropdown.includes(value)) {
                return createError({
                  message: 'Invalid value for Country',
                  path,
                });
              }
              return true;
            }),
          pincode: yup
            .string()
            .nullable()
            .test('pincode', (value, context) =>
              validateNonIndividualPincodeField(value, context, 'contactPerson')
            ),
          name: yup
            .string()
            .nullable()
            .test('name', 'Name is required', (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
            }),
          email: yup
            .string()
            .nullable()
            .matches(emailRegex, 'Invalid Email ID')
            .test('email', 'Email is required', (value, context) => {
              const { options } = context;
              return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
            }),
          mobile: yup
            .string()
            .nullable()
            .test('mobile', (value, context) => {
              const { createError, path, parent, options } = context;
              const codesList = getCountryCodes()
                .map((codes) => {
                  if (codes.label === parent.countryNameAndCode) {
                    return codes.countryCode;
                  }
                })
                .filter((ele) => ele)
                .toString();
              if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Mobile is required',
                  path,
                });
              }
              // if (value && parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
              //   return createError({
              //     message: 'Invalid Mobile number',
              //     path,
              //   });
              // }
              if (
                value &&
                !isValidPhoneNumber(
                  parent?.countryNameAndCode?.split(':')[1].trim() + value,
                  codesList as CountryCode
                )
              ) {
                return createError({
                  message: 'Invalid Mobile number',
                  path,
                });
              }

              return true;
            }),
          countryNameAndCode: yup
            .string()
            .nullable()
            .test('countryNameAndCode', (value, context) => {
              const { createError, path, parent, options } = context;
              const codesList = getCountryCodes()
                .map((codes) => {
                  if (codes.label === value) {
                    return codes.countryCode;
                  }
                })
                .filter((ele) => ele)
                .toString();
              if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
                return createError({
                  message: 'Country Code is required',
                  path,
                });
              }
              if (
                parent.mobile &&
                !isValidPhoneNumber(
                  value?.split(':')[1].trim() + parent.mobile,
                  codesList as CountryCode
                )
              ) {
                return createError({
                  message: 'Invalid Mobile number',
                  path,
                });
              }

              return true;
            }),
        }),
        address: yup.object().shape({
          correspondence: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) => {
                const { options } = context;
                return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
              }),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
                if (
                  !fetchedFromKRA &&
                  !value &&
                  shouldValidateUponSaveLater(options.context?.saveType)
                ) {
                  return false;
                }
                return true;
              }),
            address3: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 3 format [special characters are not allowed except -/',&()#:.]"
              ),
            // .test('address3', 'Address line 3 is required', (value, context) => {
            //   const { options } = context;
            //   const { context: optionsContext, index } = options as InternalOptions<Values> & {
            //     index: number;
            //   };
            //   const { applicants = [] } = optionsContext || {};
            //   const currentApplicant = applicants[index] || {};
            //   const { fetchedFromKRA = null } = currentApplicant.address.correspondence || {};
            //   if (
            //     !fetchedFromKRA &&
            //     !value &&
            //     shouldValidateUponSaveLater(options.context?.saveType)
            //   ) {
            //     return false;
            //   }
            //   return true;
            // }),
            pincode: yup
              .string()
              .nullable()
              .test('pincode', (value, context) =>
                validateNonIndividualPincodeField(value, context, 'correspondence')
              ),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) => {
                const { options } = context;
                return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
              }),
            // state: yup
            //   .string()
            //   .nullable()
            //   .test('state', 'State is required', (value, context) => {
            //     const { options } = context;
            //     return shouldValidateUponSaveLater(options.context?.saveType) ? !!value : true;
            //   }),
            state: yup
              .string()
              .nullable()
              .test('state', (value, context) => {
                const { path, createError, parent, options } = context;
                const { context: optionsContext } = options;
                const fieldValue = value === undefined ? '' : value;
                const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
                if (
                  fieldValue &&
                  !isIndia &&
                  shouldValidateUponSaveLater(optionsContext?.saveType) &&
                  !stateRegexOtherThanIndia.test(fieldValue as string)
                ) {
                  return createError({
                    message: 'Invalid State',
                    path,
                  });
                }
                return true;
              }),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext } =
                  options as InternalOptions<NonIndividualContactValues>;
                const { countryDropdown = [] } = optionsContext || {};
                if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
                  return createError({
                    message: 'Country is required',
                    path,
                  });
                }
                if (value && !countryDropdown.includes(value)) {
                  return createError({
                    message: 'Invalid value for Country',
                    path,
                  });
                }
                return true;
              }),
          }),
          permanent: yup.object().shape({
            address1: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address1', 'Address line 1 is required', (value, context) => {
                const { options } = context;
                return shouldValidateUponSaveLater(options.context?.saveType)
                  ? validatePermanentAddressFields(
                      value,
                      context,
                      APPLICATION_TYPE.NON_INDIVIDUAL,
                      flowType
                    )
                  : true;
              }),
            address2: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
              )
              .test('address2', 'Address line 2 is required', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { fetchedFromKRA = null } = currentApplicant.address.permanent || {};
                if (!fetchedFromKRA && shouldValidateUponSaveLater(options.context?.saveType)) {
                  return validatePermanentAddressFields(
                    value,
                    context,
                    APPLICATION_TYPE.NON_INDIVIDUAL,
                    flowType
                  );
                }
                return true;
              }),
            address3: yup
              .string()
              .nullable()
              .matches(
                addressRegex,
                "Invalid address line 3 format [special characters are not allowed except -/',&()#:.]"
              ),
            // .test('address3', 'Address line 3 is required', (value, context) => {
            //   const { options } = context;
            //   const { context: optionsContext, index } = options as InternalOptions<Values> & {
            //     index: number;
            //   };
            //   const { applicants = [] } = optionsContext || {};
            //   const currentApplicant = applicants[index] || {};
            //   const { fetchedFromKRA = null } = currentApplicant.address.permanent || {};
            //   if (!fetchedFromKRA && shouldValidateUponSaveLater(options.context?.saveType)) {
            //     return validatePermanentAddressFields(
            //       value,
            //       context,
            //       APPLICATION_TYPE.NON_INDIVIDUAL
            //     );
            //   }
            //   return true;
            // }),
            pincode: yup
              .string()
              .nullable()
              .test('pincode', (value, context) => {
                const { options } = context;
                const { context: optionsContext, index } = options as InternalOptions<Values> & {
                  index: number;
                };
                const { applicants = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { permanentAddressSameAsCorresponding = false } =
                  currentApplicant.address.correspondence || {};
                if (!permanentAddressSameAsCorresponding) {
                  return validateNonIndividualPincodeField(value, context, 'permanent');
                }
                return true;
              }),
            city: yup
              .string()
              .nullable()
              .test('city', 'City is required', (value, context) => {
                const { options } = context;
                return shouldValidateUponSaveLater(options.context?.saveType)
                  ? validatePermanentAddressFields(
                      value,
                      context,
                      APPLICATION_TYPE.NON_INDIVIDUAL,
                      flowType
                    )
                  : true;
              }),
            // state: yup
            //   .string()
            //   .nullable()
            //   .test('state', 'State is required', (value, context) => {
            //     const { options } = context;
            //     return shouldValidateUponSaveLater(options.context?.saveType)
            //       ? validatePermanentAddressFields(value, context, APPLICATION_TYPE.NON_INDIVIDUAL)
            //       : true;
            //   }),
            state: yup
              .string()
              .nullable()
              .test('state', (value, context) => {
                const { path, createError, parent, options } = context;
                const { context: optionsContext } = options;
                const fieldValue = value === undefined ? '' : value;
                const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
                if (
                  fieldValue &&
                  !isIndia &&
                  shouldValidateUponSaveLater(optionsContext?.saveType) &&
                  !stateRegexOtherThanIndia.test(fieldValue as string)
                ) {
                  return createError({
                    message: 'Invalid State',
                    path,
                  });
                }
                return true;
              }),
            country: yup
              .string()
              .nullable()
              .test('country', (value, context) => {
                const { options, createError, path } = context;
                const { context: optionsContext, index } =
                  options as InternalOptions<NonIndividualContactValues> & {
                    index: number;
                  };
                const { applicants = [], countryDropdown = [] } = optionsContext || {};
                const currentApplicant = applicants[index] || {};
                const { permanentAddressSameAsCorresponding = false } =
                  currentApplicant.address.correspondence || {};
                if (!permanentAddressSameAsCorresponding) {
                  if (!value && shouldValidateUponSaveLater(options.context?.saveType)) {
                    return createError({
                      message: 'Country is required',
                      path,
                    });
                  }
                  if (value && !countryDropdown.includes(value)) {
                    return createError({
                      message: 'Invalid value for Country',
                      path,
                    });
                  }
                }
                return true;
              }),
            // .test('country', 'Country is required', (value, context) =>
            //   validatePermanentAddressFields(value, context,APPLICATION_TYPE.INDIVIDUAL)
            // ),
          }),
        }),
      })
    ),
  });

export const nonIndividualDocumentDetailsSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      documents: yup.array().of(
        yup.object().shape({
          documentsList: yup.array().of(
            yup.object().shape({
              documentName: yup
                .string()
                .nullable()
                .test(
                  'documentName',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, NonIndividualDocValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<NonIndividualDocValues> & { index: number };
                    const { applicants = [], banks } =
                      optionsContext || ({} as NonIndividualDocValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const {
                      required,
                      documentName,
                      documentType,
                      options: optionsDropdown,
                    } = applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    const fieldValue = optionsDropdown && value && optionsDropdown.includes(value);
                    if (
                      optionsDropdown &&
                      shouldValidateUponSaveLater(optionsContext?.saveType || '')
                    ) {
                      if (
                        documentType === 'bankAccountProof' &&
                        !fieldValue &&
                        banks &&
                        banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
                          .length !== 0
                      ) {
                        return createError({
                          message: `Please Select ${documentName}`,
                          path,
                        });
                      }
                      if (!fieldValue && required === 'true') {
                        return createError({
                          message: `Please Select ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
              documentId: yup
                .string()
                .nullable()
                .test(
                  'documentId',
                  (
                    value: string | undefined | null,
                    context: yup.TestContext<Record<string, NonIndividualDocValues>>
                  ) => {
                    const { options, createError, path } = context;
                    const { context: optionsContext, parent } =
                      options as InternalOptions<NonIndividualDocValues> & { index: number };
                    const { applicants = [], banks } =
                      optionsContext || ({} as NonIndividualDocValues);
                    const { uniqueKey = '' } = parent || {};
                    const indexes = uniqueKey.split('-');
                    const { required, documentName } =
                      applicants[indexes[0]].documents[indexes[1]].documentsList[indexes[2]];
                    if (required === 'false') {
                      return true;
                    }
                    if (!value && shouldValidateUponSaveLater(optionsContext?.saveType || '')) {
                      if (
                        !value &&
                        banks &&
                        banks.filter((bank) => !bank.pennydropVerified && bank.defaultBankAccount)
                          .length !== 0
                      ) {
                        return createError({
                          message: `Please upload ${documentName}`,
                          path,
                        });
                      }
                    }
                    return true;
                  }
                ),
            })
          ),
        })
      ),
    })
  ),
  documentDeclarationCheck: yup
    .boolean()
    .nullable()
    .test('documentDeclarationCheck', (value, context) => {
      const fieldValue = value === null ? '' : value;
      const {
        createError,
        path,
        options: { context: optionsContext },
      } = context;
      if (
        !fieldValue &&
        shouldValidateUponSaveLater(optionsContext?.saveType || '') &&
        IsOutBoundFundFlow(optionsContext?.fundFlowType)
      ) {
        return createError({
          message: 'Acknowledgement is required',
          path,
        });
      }
      return true;
    }),
});

export const nonIndividualAuthorisedSignatories = (ifXalt: boolean) =>
  yup.object().shape({
    name: yup.string().nullable().required('Name is required'),
    identificationType: yup.string().nullable().required('Id type is required'),
    taxIdNumber: yup
      .string()
      .nullable()
      .test('taxIdNumber', (value, context) => {
        const { path, createError, options } = context;
        const { context: optionsContext } = options as InternalOptions<Groups[]>;
        const authorisedSignatoriesPanNumbers = optionsContext
          ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.taxIdNumber))
          .flat();
        if (!value) {
          return createError({
            message: 'Taxpayer/Equivalent ID No is required',
            path,
          });
        }
        if (authorisedSignatoriesPanNumbers && authorisedSignatoriesPanNumbers.includes(value)) {
          return createError({
            message:
              'There is already same Taxpayer/Equivalent ID No for an Authorised Signatory associated with this application',
            path,
          });
        }
        return true;
      }),

    // pan: yup
    //   .string()
    //   .nullable()
    //   .uppercase()
    //   .length(10, 'PAN must be exactly 10 characters')
    //   .matches(individualPanRegex, 'Only individual PANs are allowed')
    //   .test('pan', (value, context) => {
    //     const { path, createError, options } = context;
    //     const { context: optionsContext } = options as InternalOptions<Groups[]>;
    //     const authorisedSignatoriesPanNumbers = optionsContext
    //       ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.pan))
    //       .flat();
    //     if (!value) {
    //       return createError({
    //         message: 'PAN is required',
    //         path,
    //       });
    //     }
    //     if (authorisedSignatoriesPanNumbers && authorisedSignatoriesPanNumbers.includes(value)) {
    //       return createError({
    //         message:
    //           'There is already same pan for an Authorised Signatory associated with this application',
    //         path,
    //       });
    //     }

    //     return true;
    //   }),
    mobile: yup
      .string()
      .nullable()
      .test('mobile', (value, context) => {
        const { path, createError, options, parent } = context;
        const { context: optionsContext } = options as InternalOptions<Groups[]>;
        const authorisedSignatoriesMobileNumbers = optionsContext
          ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.mobile))
          .flat();
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile Number is required',
            path,
          });
        }
        // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
        //   return createError({
        //     message: 'Invalid Mobile number',
        //     path,
        //   });
        // }
        if (
          !isValidPhoneNumber(
            parent?.countryNameAndCode?.split(':')[1].trim() + value,
            codesList as CountryCode
          )
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (
          authorisedSignatoriesMobileNumbers &&
          authorisedSignatoriesMobileNumbers.includes(value)
        ) {
          return createError({
            message:
              'There is already same mobile number for an Authorised Signatory associated with this application',
            path,
          });
        }

        return true;
      }),

    countryNameAndCode: yup
      .string()
      .nullable()
      .test('countryNameAndCode', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === value) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Country Code is required',
            path,
          });
        }
        if (
          parent.mobile &&
          !isValidPhoneNumber(value?.split(':')[1].trim() + parent.mobile, codesList as CountryCode)
        ) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }

        return true;
      }),
    email: yup
      .string()
      .nullable()
      .matches(emailRegex, 'invalid Email ID')
      .test('email', (value, context) => {
        const { path, createError, options } = context;
        const { context: optionsContext } = options as InternalOptions<Groups[]>;
        const authorisedSignatoriesEmailID = optionsContext
          ?.map((groups) => groups.groupsignatories.map((signatory) => signatory.email))
          .flat();
        if (!value) {
          return createError({
            message: 'Email ID is required',
            path,
          });
        }
        if (authorisedSignatoriesEmailID && authorisedSignatoriesEmailID.includes(value)) {
          return createError({
            message:
              'There is already same Email ID for an Authorised Signatory associated with this application',
            path,
          });
        }

        return true;
      }),
    designation: yup.string().nullable().required('Designation is required'),
    designationOther: yup
      .string()
      .nullable()
      .when('designation', {
        is: (designation: string) => MASTER_DESIGNATION[designation] === 'Other' && ifXalt,
        then: yup
          .string()
          .nullable()
          .test('designationOther', (value, context) => {
            const { path, createError } = context;
            if (!value) {
              return createError({
                message: 'Please Specify Designation',
                path,
              });
            }
            return true;
          }),
      }),
    pepStatus: yup
      .string()
      .oneOf(PEPsMasters, 'Invalid value for PEP Status')
      .test('pepStatus', (value, context) => {
        const { path, createError } = context;
        if (!value && ifXalt) {
          return createError({
            message: 'PEP Status is required',
            path,
          });
        }
        return true;
      }),
    // .required('PEP status is required'),
    dob: yup
      .string()
      .nullable()
      .test('dob', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;

        if (!fieldValue && ifXalt) {
          return createError({
            message: 'Date of birth is required',
            path,
          });
        }
        if (
          fieldValue &&
          parent.panNumber &&
          individualPanRegex.test(parent.panNumber) &&
          isMinor(fieldValue || '')
        ) {
          return createError({
            message: 'Age should be greater than 18',
            path,
          });
        }
        if (
          fieldValue &&
          parent.panNumber &&
          individualPanRegex.test(parent.panNumber) &&
          maxAge(fieldValue || '')
        ) {
          return createError({
            message: 'Age should be less than 125',
            path,
          });
        }
        return true;
      }),
  });

const fieldValidation = (
  value: string | undefined | null | number,
  context: yup.TestContext<Record<string, uboDomestic | uboForeign>>,
  mes: string
) => {
  const fieldValue = value === undefined ? '' : value;
  const { path, createError, parent } = context;
  if (!fieldValue && !parent.isFetchData) {
    return createError({
      message: `${mes} is required`,
      path,
    });
  }
  return true;
};

export const nonIndividualUboWithPan = yup.object().shape({
  panNumber: yup
    .string()
    .nullable()
    .uppercase()
    .test('panNumber', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<uboDomestic[]>;

      const uboPanNumbers = optionsContext?.map((ubo) => ubo.panNumber);
      if (!value) {
        return createError({
          message: 'Taxpayer ID Number/PAN/Equivalent ID Number is required',
          path,
        });
      }
      if (uboPanNumbers && uboPanNumbers.includes(value)) {
        return createError({
          message:
            'There is already same Taxpayer ID Number/PAN/Equivalent ID Number for an Ultimate Beneficiary Ownership (UBO) associated with this application',
          path,
        });
      }

      return true;
    }),

  dob: yup
    .string()
    .nullable()
    .test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (!fieldValue) {
        return createError({
          message: 'Date of birth is required',
          path,
        });
      }
      if (
        parent.panNumber &&
        individualPanRegex.test(parent.panNumber) &&
        isMinor(fieldValue || '')
      ) {
        return createError({
          message: 'Age should be greater than 18',
          path,
        });
      }
      if (
        parent.panNumber &&
        individualPanRegex.test(parent.panNumber) &&
        maxAge(fieldValue || '')
      ) {
        return createError({
          message: 'Age should be less than 125',
          path,
        });
      }
      return true;
    }),
  name: yup
    .string()
    .nullable()
    .test('name', (value, context) => {
      return fieldValidation(value, context, 'Name');
    }),
  identificationType: yup
    .string()
    .nullable()
    .test('identificationType', (value, context) => {
      return fieldValidation(value, context, 'Identification Type');
    }),
  // typeOfUBO: yup
  //   .string()
  //   .nullable()
  //   .oneOf(Object.keys(UboTypeMaster), 'Invalid value for UBO Type'),
  percentageOfBeneficialInterest: yup
    .number()
    .nullable()
    .test('percentageOfBeneficialInterest', (value, context) => {
      const fieldValue = value;
      const { path, createError, parent } = context;
      if (fieldValue === null || (fieldValue === undefined && !parent.isFetchData)) {
        return createError({
          message: `Percentage Of Beneficial Interest is required`,
          path,
        });
      }
      if (
        fieldValue === 0 &&
        !parent.isFetchData
        //  && !checkUBOTypeIsTrust(parent.typeOfUBO)
      ) {
        return createError({
          message: `Percentage Of Beneficial Interest should be greater 0`,
          path,
        });
      }
      if (fieldValue) {
        if (fieldValue < 0 && !parent.isFetchData) {
          return createError({
            message: `Percentage Of Beneficial Interest should be greater than 0`,
            // ${
            //   checkUBOTypeIsTrust(parent.typeOfUBO) ? ' or equal to' : ''
            // } 0`,
            path,
          });
        }
        if (fieldValue > 100 && !parent.isFetchData) {
          return createError({
            message: `Percentage Of Beneficial Interest must not exceed 100%`,
            path,
          });
        }
      }
      return true;
    }),
  countryOfTaxResidency: yup
    .string()
    .nullable()
    .test('countryOfTaxResidency', (value, context) => {
      return fieldValidation(value, context, 'Country Of Tax Residency');
    }),
  cpUboCode: yup
    .string()
    .nullable()
    .oneOf(Object.keys(CpUboCodesMaster), 'Invalid value for CP/UBO Code')
    .test('cpUboCode', (value, context) => {
      return fieldValidation(value, context, 'Cp/UboCode');
    }),
  placeAndCountryOfBirth: yup
    .string()
    .nullable()
    .test('placeAndCountryOfBirth', (value, context) => {
      return fieldValidation(value, context, 'Place And Country Of Birth');
    }),
  occupation: yup
    .string()
    .nullable()
    .oneOf(occupationDetailsMasters, 'Invalid value for Occupation')
    .test('occupation', (value, context) => {
      return fieldValidation(value, context, 'Occupation');
    }),
  gender: yup
    .string()
    .nullable()
    .test('gender', (value, context) => {
      return fieldValidation(value, context, 'Gender');
    }),
  nationality: yup
    .string()
    .nullable()
    .test('nationality', (value, context) => {
      return fieldValidation(value, context, 'Nationality');
    }),
  fatherName: yup
    .string()
    .nullable()
    .test('fatherName', (value, context) => {
      return fieldValidation(value, context, 'FatherName');
    }),
  ckycNumber: yup
    .string()
    .nullable()
    // .length(14, 'Invalid CKYC Number')
    .test('ckycNumber', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, options, parent } = context;
      //eslint-disable-next-line
      // const { context: optionsContext } = options as InternalOptions<ubo[]>;
      if (!fieldValue && !parent.isFetchData) {
        return true;
      } else if (
        !ckycNumberRegex.test(fieldValue as string) &&
        !parent.isFetchData &&
        !parent.maskedCkycNo
      ) {
        return createError({
          message: 'Invalid CKYC Number',
          path,
        });
      }
      // const uboCkycNumbers = optionsContext?.map((ubo) => Number(ubo.ckycNumber).toString());
      // if (uboCkycNumbers && uboCkycNumbers.includes(fieldValue as string) && !parent.isFetchData) {
      //   return createError({
      //     message:
      //       'There is already same CKYC Number for an Ultimate Beneficiary Ownership (UBO) associated with this application',
      //     path,
      //   });
      // }
      return true;
    }),
  address2: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "Invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
    )
    .test('address2', (value, context) => {
      return fieldValidation(value, context, 'Address Line 1');
    }),
  address3: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "Invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
    )
    .test('address3', (value, context) => {
      return fieldValidation(value, context, 'Address Line 2');
    }),
  city: yup
    .string()
    .nullable()
    .test('city', (value, context) => {
      return fieldValidation(value, context, 'City');
    }),
  state: yup
    .string()
    .nullable()
    .test('state', (value, context) => {
      const { path, createError, parent, options } = context;
      const { context: optionsContext } = options;
      const fieldValue = value === undefined ? '' : value;
      const isIndia = ['india', 'indian'].includes(parent.country?.toLowerCase() || '');
      if (
        fieldValue &&
        !isIndia &&
        shouldValidateUponSaveLater(optionsContext?.saveType) &&
        !stateRegexOtherThanIndia.test(fieldValue as string)
      ) {
        return createError({
          message: 'Invalid State',
          path,
        });
      }
      return fieldValidation(value, context, 'State');
    }),
  country: yup
    .string()
    .nullable()
    .test('country', (value, context) => {
      return fieldValidation(value, context, 'Country');
    }),
  pincode: yup
    .string()
    .nullable()
    .test('pincode', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (
        !fieldValue &&
        ['india', 'indian'].includes(parent.country?.toLowerCase() || '') &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Pincode is required',
          path,
        });
      } else if (
        ['india', 'indian'].includes(parent.country?.toLowerCase() || '') &&
        !indianPin.test(fieldValue as string) &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Pincode length should be 6 digits',
          path,
        });
      } else if (
        !['india', 'indian'].includes(parent.country?.toLowerCase() || '') &&
        !pinCodeRegexOtherThanIndia.test(fieldValue as string) &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Invalid Pincode',
          path,
        });
      }
      return true;
    }),
});

export const nonIndividualUboWithoutPan = yup.object().shape({
  // panNumber: yup
  //   .string()
  //   .nullable()
  //   .uppercase()
  //   .test('panNumber', (value, context) => {
  //     const { path, createError, options } = context;
  //     const { context: optionsContext } = options as InternalOptions<ubo[]>;

  //     const uboPanNumbers = optionsContext?.map((ubo) => ubo.panNumber);
  //     if (!value) {
  //       return createError({
  //         message: 'Taxpayer ID Number/Equivalent ID Number is required',
  //         path,
  //       });
  //     }
  //     if (uboPanNumbers && uboPanNumbers.includes(value)) {
  //       return createError({
  //         message:
  //           'There is already same Taxpayer ID Number/Equivalent ID Number for an Ultimate Benificiary Ownership (UBO) associated with this application',
  //         path,
  //       });
  //     }

  //     return true;
  //   }),

  taxIdNumber: yup
    .string()
    .nullable()
    .test('taxIdNumber', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<uboForeign[]>;

      const taxID = optionsContext?.map((ubo) => ubo.taxIdNumber);
      if (!value) {
        return createError({
          message: 'Taxpayer ID Number/Equivalent ID Number is required',
          path,
        });
      }
      if (taxID && taxID.includes(value)) {
        return createError({
          message:
            'There is already same Taxpayer ID Number/Equivalent ID Number for an Ultimate Beneficiary Ownership (UBO) associated with this application',
          path,
        });
      }

      return true;
    }),

  dob: yup
    .string()
    .nullable()
    .test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (!fieldValue) {
        return createError({
          message: 'Date of birth is required',
          path,
        });
      }
      // if (
      //   parent.panNumber &&
      //   individualPanRegex.test(parent.panNumber) &&
      //   isMinor(fieldValue || '')
      // ) {
      //   return createError({
      //     message: 'Age should be greater than 18',
      //     path,
      //   });
      // }
      // if (
      //   parent.panNumber &&
      //   individualPanRegex.test(parent.panNumber) &&
      //   maxAge(fieldValue || '')
      // ) {
      //   return createError({
      //     message: 'Age should be less than 125',
      //     path,
      //   });
      // }
      return true;
    }),
  name: yup
    .string()
    .nullable()
    .test('name', (value, context) => {
      return fieldValidation(value, context, 'Name');
    }),
  identificationType: yup
    .string()
    .nullable()
    .test('identificationType', (value, context) => {
      return fieldValidation(value, context, 'Identification Type');
    }),
  percentageOfBeneficialInterest: yup
    .number()
    .nullable()
    .test('percentageOfBeneficialInterest', (value, context) => {
      const fieldValue = value;
      const { path, createError, parent } = context;
      // if (fieldValue === null || (fieldValue === undefined && !parent.isFetchData)) {
      //   return createError({
      //     message: `Percentage Of Beneficial Interest is required`,
      //     path,
      //   });
      // }
      // if (fieldValue === 0 && !parent.isFetchData) {
      //   return createError({
      //     message: `Percentage Of Beneficial Interest should be greater 0`,
      //     path,
      //   });
      // }
      if (fieldValue) {
        if (fieldValue < 0 && !parent.isFetchData) {
          return createError({
            message: `Percentage Of Beneficial Interest should be greater 0`,
            path,
          });
        }
        if (fieldValue > 100 && !parent.isFetchData) {
          return createError({
            message: `Percentage Of Beneficial Interest must not exceed 100%`,
            path,
          });
        }
      }
      return true;
    }),
  countryOfTaxResidency: yup
    .string()
    .nullable()
    .test('countryOfTaxResidency', (value, context) => {
      return fieldValidation(value, context, 'Country Of Tax Residency');
    }),
  cpUboCode: yup
    .string()
    .nullable()
    .oneOf(Object.keys(CpUboCodesMaster), 'Invalid value for CP/UBO Code')
    .test('cpUboCode', (value, context) => {
      return fieldValidation(value, context, 'Cp/UboCode');
    }),
  placeAndCountryOfBirth: yup
    .string()
    .nullable()
    .test('placeAndCountryOfBirth', (value, context) => {
      return fieldValidation(value, context, 'Place And Country Of Birth');
    }),
  occupation: yup
    .string()
    .nullable()
    .test('occupation', (value, context) => {
      const { path, createError, parent } = context;
      if (![...occupationDetailsMasters, ''].includes(value || '')) {
        return createError({
          message: 'Invalid value for Occupation',
          path,
        });
      }
      return true;
    }),
  gender: yup
    .string()
    .nullable()
    .test('gender', (value, context) => {
      return fieldValidation(value, context, 'Gender');
    }),
  nationality: yup
    .string()
    .nullable()
    // .oneOf(nationalitiesMasters, 'Invalid value for Nationality')
    .test('nationality', (value, context) => {
      return fieldValidation(value, context, 'Nationality');
    }),
  // fatherName: yup
  //   .string()
  //   .nullable()
  //   .test('fatherName', (value, context) => {
  //     return fieldValidation(value, context, 'FatherName');
  //   }),
  ckycNumber: yup
    .string()
    .nullable()
    .length(14, 'Invalid CKYC Number')
    .test('ckycNumber', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, options, parent } = context;
      const { context: optionsContext } = options as InternalOptions<uboForeign[]>;
      if (!fieldValue && !parent.isFetchData) {
        return true;
      } else if (!numberRegex.test(fieldValue as string) && !parent.isFetchData) {
        return createError({
          message: 'CKYC Number allows only digits',
          path,
        });
      }
      const uboCkycNumbers = optionsContext?.map((ubo) => Number(ubo.ckycNumber).toString());
      if (uboCkycNumbers && uboCkycNumbers.includes(fieldValue as string) && !parent.isFetchData) {
        return createError({
          message:
            'There is already same CKYC Number for an Ultimate Beneficiary Ownership (UBO) associated with this application',
          path,
        });
      }
      return true;
    }),
  address2: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "invalid address line 1 format [special characters are not allowed except -/',&()#:.]"
    )
    .test('address2', (value, context) => {
      return fieldValidation(value, context, 'Address Line 1');
    }),
  address3: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "invalid address line 2 format [special characters are not allowed except -/',&()#:.]"
    )
    .test('address3', (value, context) => {
      return fieldValidation(value, context, 'Address Line 2');
    }),
  city: yup
    .string()
    .nullable()
    .test('city', (value, context) => {
      return fieldValidation(value, context, 'City');
    }),
  country: yup
    .string()
    .nullable()
    .test('country', (value, context) => {
      return fieldValidation(value, context, 'Country');
    }),
  pincode: yup
    .string()
    .nullable()
    .test('pincode', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      if (!fieldValue) {
        return true;
      } else if (
        parent.country?.toLowerCase() === 'india' &&
        !indianPin.test(fieldValue as string) &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Pincode length should be 6 digits',
          path,
        });
      } else if (
        parent.country?.toLowerCase() !== 'india' &&
        !alphaNumeric.test(fieldValue as string) &&
        !parent.isFetchData
      ) {
        return createError({
          message: 'Invalid Pincode',
          path,
        });
      }
      return true;
    }),
});

export const nonIndividualControllingPersons = yup.object().shape({
  name: yup.string().nullable().required('Name of controlling person is required'),
  correspondenceAddress: yup
    .string()
    .nullable()
    .matches(
      addressRegex,
      "invalid address format [special characters are not allowed except -/',&()#:.]"
    )
    .required('Correspondence address is required'),
  countryOfResidense: yup
    .string()
    .nullable()
    .required('Country of residence for tax purposes is required'),
  issuingCountry: yup.string().nullable().required('Issuing country is required'),
  controllingPersonType: yup.string().nullable().required('Controlling Person Type is required'),
  indentificationType: yup.string().nullable().required('Indentification Type is required'),
  indentificationNumber: yup
    .string()
    .nullable()
    .test('indentificationNumber', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<ControllingPersons[]>;
      const indentificationNumberArr = optionsContext?.map(
        (person) => person.indentificationNumber
      );
      if (!value) {
        return createError({
          message: 'Indentification Number is required',
          path,
        });
      }
      if (value && !alphaNumeric.test(value)) {
        return createError({
          message: 'Special Characters are Not allowed',
          path,
        });
      }
      if (indentificationNumberArr && indentificationNumberArr.includes(value)) {
        return createError({
          message:
            'There is already same Indentification Number for a Controlling Persons associated with this application',
          path,
        });
      }

      return true;
    }),
  occupationType: yup.string().nullable().required('Occupation Type is required'),
  occupation: yup
    .string()
    .nullable()
    .oneOf(occupationDetailsMasters, 'Invalid value for Occupation')
    .required('Occupation is required'),
  dateOfBirth: yup
    .string()
    .nullable()
    .test('dateOfBirth', (value, context) => {
      const { path, createError } = context;
      if (!value) {
        return createError({
          message: 'Date of Birth is required',
          path,
        });
      }
      if (isMinor(value)) {
        return createError({
          message: 'Age should be greater than 18',
          path,
        });
      }
      if (maxAge(value)) {
        return createError({
          message: 'Age should be less than 125',
          path,
        });
      }
      return true;
    }),
  countryOfBirth: yup.string().nullable().required('Country Of Birth is required'),
  nationality: yup.string().nullable().required('Nationality is required'),
  tin: yup
    .string()
    .nullable()
    .test('tin', (value, context) => {
      const { path, createError, options } = context;
      const { context: optionsContext } = options as InternalOptions<ControllingPersons[]>;
      const controllingPersons = optionsContext?.map((person) => person.tin);
      if (!value) {
        return createError({
          message: 'TIN is required',
          path,
        });
      }
      if (value && !alphaNumeric.test(value)) {
        return createError({
          message: 'Special Characters are Not allowed',
          path,
        });
      }
      if (controllingPersons && controllingPersons.includes(value)) {
        return createError({
          message:
            'There is already same Tin for a Controlling Persons associated with this application',
          path,
        });
      }

      return true;
    }),
});

type errorObj = { fieldPath: string; fieldName: string };

const subQuestionsValidation = (
  fatca: nonIndividualQuestionsFatca,
  path: string
): errorObj | errorObj[] | undefined => {
  if (
    !fatca.answer &&
    fatca.isVisible &&
    fatca.backend_key &&
    fatca.isMandatory === 'true' &&
    fatca.question_type !== 'Controlling_person_details'
  ) {
    const fieldPath =
      path + '.' + getSubQuestionsIndex(fatca.id.split('Q')[1].split('.'), '', true);
    return {
      fieldPath: fieldPath,
      fieldName:
        fatca.question_type === 'single_choice_radio'
          ? 'Field is required'
          : fatca.question_text
          ? fatca.question_text + ' is required'
          : (fatca.placeholder || 'Field') + ' is required',
    };
  }
  if (
    fatca.answer &&
    fatca.isVisible &&
    fatca.backend_key &&
    fatca.validation === 'alphaNumeric' &&
    !alphaNumeric.test(fatca.answer)
  ) {
    const fieldPath =
      path + '.' + getSubQuestionsIndex(fatca.id.split('Q')[1].split('.'), '', true);
    return {
      fieldPath: fieldPath,
      fieldName: 'Special Characters are Not allowed',
    };
  }
  if (fatca.question_type === 'group' && fatca.isVisible && fatca.sub_questions?.length) {
    return fatca.sub_questions
      ?.map((qun) => subQuestionsValidation(qun, path) as errorObj)
      .filter((ele: errorObj) => ele)
      .flat();
  }
};

export const nonIndividualFatcaSchema = yup.object().shape({
  applicants: yup.array().of(
    yup.object().shape({
      typeOfAddressProvidedAtKRA: yup
        .string()
        .nullable()
        .when('wishToUploadFatcaDocument', {
          is: (wishToUploadFatcaDocument: boolean | null) => !wishToUploadFatcaDocument,
          then: yup
            .string()
            .nullable()
            .oneOf(
              addressTypesMastersforoutbound,
              'Invalid value for Type of Address Provided At KRA'
            )
            .test('typeOfAddressProvidedAtKRA', (value, context) => {
              const {
                options: { context: optionsContext },
                path,
                createError,
              } = context;
              if (
                !value &&
                shouldValidateUponSaveLater(optionsContext?.saveType) &&
                IsOutBoundFundFlow(optionsContext?.fundFlowType)
              ) {
                return createError({
                  message: 'Please select type of address provided',
                  path,
                });
              }
              return true;
            }),
        }),
      fatcadetail: yup
        .array()
        .nullable()
        .of(
          yup.object().shape({
            answer: yup
              .string()
              .nullable()
              .when('wishToUploadFatcaDocument', {
                is: (wishToUploadFatcaDocument: boolean | null) => !wishToUploadFatcaDocument,
                then: yup
                  .string()
                  .nullable()
                  .test('answer', (value, context) => {
                    const { path, createError, parent, options } = context;
                    if (shouldValidateUponSaveLater(options.context?.saveType)) {
                      if (
                        !value &&
                        parent.isVisible &&
                        parent.isMandatory === 'true' &&
                        parent.backend_key &&
                        parent.question_type !== 'single_choice_radio'
                      ) {
                        return createError({
                          message:
                            parent.question_type === 'open_text_field'
                              ? (parent.placeholder || 'Field') + ' is required'
                              : parent.question_text
                              ? parent.question_text + ' is required'
                              : (parent.placeholder || 'Field') + ' is required',
                          path,
                        });
                      }
                      if (
                        value &&
                        parent.isVisible &&
                        parent.backend_key &&
                        parent.validation === 'alphaNumeric' &&
                        !alphaNumeric.test(value)
                      ) {
                        return createError({
                          message: 'Special Characters are Not allowed',
                          path,
                        });
                      }
                      if (
                        parent.question_type === 'group' &&
                        parent.isVisible &&
                        parent.sub_questions
                      ) {
                        //subQuestionsValidation(value, context)
                        const res: errorObj[] = [];
                        const val = parent.sub_questions
                          ?.map((qun: nonIndividualQuestionsFatca) => {
                            const r = subQuestionsValidation(qun, path?.split('.')[0]) as errorObj;
                            return r;
                            // return (r as errorObj)
                            //   ? new yup.ValidationError(r.fieldName, '', `${r.fieldPath}.answer`)
                            //   : (r as unknown as errorObj[])?.map(
                            //       (ele: errorObj) =>
                            //         new yup.ValidationError(ele.fieldName, '', `${ele.fieldPath}.answer`)
                            //     );
                          })
                          .filter((ele: errorObj) => ele)
                          .flat();
                        // .toString();
                        if (val.length) {
                          const error = val.map((ele: errorObj) => {
                            return new yup.ValidationError(
                              ele.fieldName,
                              '',
                              `${ele.fieldPath}.answer`
                            );
                          });
                          if (error.length) {
                            return new yup.ValidationError(error);
                          }

                          // return createError({
                          //   message: 'Field is Required1',
                          //   path: `${val}.answer`,
                          // });
                        }
                        return true;
                      }
                    }
                    return true;
                  }),
              }),
          })
        ),
    })
  ),
});

export const addPlanValidation = yup.object().shape({
  planCode: yup.string().nullable().required('Plan Code is required'),
  planDescription: yup.string().nullable().required('Plan Description is required'),
  schemeNature: yup.string().nullable().required('Scheme Nature is required'),
  // registrationNumber: yup.string().nullable().required('Registration Number is required'),
  fundManagerId: yup.string().nullable().required('Investment Manager Name is required'),
  trusteeId: yup.string().nullable().required('Trustee Name is required'),
  schemeCategory: yup.string().nullable().required('Scheme Category is required'),
  minCommitmentAmount: yup
    .number()
    .nullable()
    .moreThan(0, `Minimum Capital Commitment should be greater than 0`)
    .required('Minimum Capital Commitment is required'),
  maxCommitmentAmount: yup
    .number()
    .nullable()
    .min(
      yup.ref('minCommitmentAmount'),
      'Maximum Capital Commitment should be greater than or equal to Minimum Capital Commitment'
    )
    .required('Maximum Capital Commitment is required'),
  distributorIds: yup
    .array()
    .nullable()
    .when('isApplicableForDistributor', {
      is: (isApplicableForDistributor: boolean) => isApplicableForDistributor === true,
      then: yup
        .array()
        .nullable()
        .min(1, 'Distributors required')
        .required('Distributors required'),
    }),
  managementFee: yup.string().nullable().required('Management Fee is required'),
  totalExpense: yup.number().nullable().required('Total Expense is required'),
  isPlacementFeeApplicable: yup
    .string()
    .nullable()
    .required('Placement Fee Applicable is required'),
  placementFeeType: yup
    .string()
    .nullable()
    .when('isPlacementFeeApplicable', {
      is: (val: string | null | undefined) => isFieldApplicable(val),
      then: (schema) =>
        schema
          .required('Placement Fee Type is required')
          .oneOf(Object.keys(feeTypeMaster), 'Invalid Placement Fee Type'),
      otherwise: (schema) => schema.nullable(),
    }),

  minPlacementFee: yup
    .number()
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    .when('placementFeeType', {
      is: (val: string | null | undefined) => isFieldTypeVariable(val),
      then: (schema) =>
        schema
          .min(0, 'Min Placement Fee must be >= 0')
          .max(100, 'Min Placement Fee cannot be more than 100')
          .required('Min Placement Fee is required'),
      otherwise: (schema) => schema.nullable(), // no validation when fixed
    }),

  maxPlacementFee: yup
    .number()
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    .when('placementFeeType', {
      is: (val: string | null | undefined) => isFieldTypeVariable(val),
      then: (schema) =>
        schema
          .min(0, 'Max Placement Fee must be >= 0')
          .max(100, 'Max Placement Fee cannot be more than 100')
          .when('minPlacementFee', (minFee: number | null, s: any) => {
            if (minFee !== null && !isNaN(Number(minFee))) {
              return s.min(
                minFee,
                'Max Placement Fee must be greater than or equal to Min Placement Fee'
              );
            }
            return s;
          })
          .required('Max Placement Fee is required'),
      otherwise: (schema) => schema.nullable(), // no validation when fixed
    }),

  placementFee: yup
    .number()
    .nullable()
    .test('placementFee', 'Placement Fee is required', function (value) {
      const { placementFeeType, isPlacementFeeApplicable, minPlacementFee, maxPlacementFee } =
        this.parent;

      if (!isPlacementFeeApplicable) return true; // Skip validation

      // When selected type is fixed → required, between 0–100
      if (isFieldTypeFixed(placementFeeType)) {
        if (value === null || value === undefined)
          return this.createError({ message: 'Placement Fee is required' });

        if (value < 0 || value > 100)
          return this.createError({
            message: 'Fixed fee must be between 0 and 100',
          });

        return true;
      }

      // When selected type is variable → required + min & max from admin
      if (isFieldTypeVariable(placementFeeType)) {
        const min = Number(minPlacementFee);
        const max = Number(maxPlacementFee);

        if (value === null || value === undefined)
          return this.createError({ message: 'Placement Fee is required' });

        if (value < min || value > max)
          return this.createError({
            message: `Variable fee must be between ${min} and ${max}`,
          });

        return true;
      }

      return true;
    }),

  investmentPlanApplicable: yup
    .string()
    .nullable()
    .required('Investment Plan Applicable is required'),

  operatingExpenseApplicable: yup
    .string()
    .nullable()
    .required('Operating Expense Applicable is required'),
  operatingExpenseInWords: yup
    .string()
    .nullable()
    .when('operatingExpenseApplicable', {
      is: (value: string) => isFieldApplicable(value),
      then: yup.string().nullable().required('Operating Expense is required'),
    }),

  exitLoadApplicable: yup.string().nullable().required('Exit Load Applicable is required'),
  exitLoadInWords: yup
    .string()
    .nullable()
    .when('exitLoadApplicable', {
      is: (value: string) => isFieldApplicable(value),
      then: yup.string().nullable().required('Exit Load is required'),
    }),
  investmentPlanType: yup
    .string()
    .nullable()
    .when('investmentPlanApplicable', {
      is: (value: string) => isFieldApplicable(value),
      then: yup.string().nullable().required('Investment Plan is required'),
    }),
});

export const editFundValidation = yup.object().shape({
  schemeCode: yup.string().nullable().required('Scheme Code is required'),
  schemeName: yup.string().nullable().required('Scheme Name is required'),
  paymentApiKey: yup.string().nullable().required('Payment API Key is required'),
  isInvestorWithPanApplicable: yup.string().nullable().required('Flow type is required'),
  leegalityStampSeries: yup
    .string()
    .nullable()
    .when(['leegalityUseStampSeries', 'stampSeriesType'], {
      is: (useStamp: string | boolean, seriesType: unknown) =>
        useStamp?.toString() === 'true' && seriesType === 'single',
      then: (schema) =>
        schema
          .required('Stamp Paper Series is required')
          .matches(alphaNumeric, 'Special characters are not allowed'),
      otherwise: (schema) => schema.notRequired(),
    }),
  leegalityStampSeriesGroup: yup
    .string()
    .nullable()
    .when('leegalityUseStampSeries', {
      is: (val: string | boolean) => val?.toString() === 'false',
      then: (schema) =>
        schema
          .required('Stamp Paper Group is required')
          .matches(alphaNumeric, 'Special characters are not allowed'),
      otherwise: (schema) => schema.notRequired(),
    }),
  leegalityStampValue: yup
    .number()
    .nullable()
    .when('leegalityUseStampSeries', {
      is: (val: string | boolean) => val?.toString() === 'false',
      then: (schema) => schema.required('Stamp Paper Value is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  leegalityUseStampSeries: yup
    .mixed()
    .nullable()
    .required('Field is required')
    .test(
      'valid-stamp-series-choice',
      'Field is required',
      (val) => val?.toString() === 'true' || val?.toString() === 'false'
    ),
  stampSeriesType: yup
    .string()
    .nullable()
    .when('leegalityUseStampSeries', {
      is: (val: string | boolean) => val?.toString() === 'true',
      then: (schema) => schema.required('Stamp Series Type is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  multipleStampSeries: yup
    .array()
    .nullable()
    .when(['leegalityUseStampSeries', 'stampSeriesType'], {
      is: (leegalityUseStampSeries: boolean | string, stampSeriesType: string) =>
        stampSeriesType === 'multi' && leegalityUseStampSeries?.toString() === 'true',
      then: (schema) =>
        schema
          .of(
            yup.object().shape({
              stampSeries: yup
                .string()
                .nullable()
                .required('Series Number is required')
                .matches(alphaNumeric, 'Special characters are not allowed'),
              seriesQuantity: yup
                .string()
                .nullable()
                .required('Total Stamps is required')
                .matches(alphaNumeric, 'Special characters are not allowed'),
            })
          )
          .min(1, 'At least one stamp series is required')
          .max(5, 'Maximum five stamp series are allowed')
          .test('unique-series-number', 'Stamp series numbers must be unique', (value) => {
            if (!value || !value.length) return true;
            const stampSeries = value
              .map((item) => item?.stampSeries?.trim())
              .filter((item) => !!item);
            return new Set(stampSeries).size === stampSeries.length;
          }),
      otherwise: () => yup.array().nullable().notRequired(),
    }),
  journeyType: yup
    .string()
    .oneOf(Object.keys(JOURNEY_TYPE), 'Invalid Journey Type selected')
    .required('Journey Type is required'),
});

export const addFundValidation = editFundValidation.concat(addPlanValidation);
